import React, { useRef, useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { motion } from "framer-motion";
import { useDispatch } from "react-redux";
import { increment, decrement } from "../../../Redux/Action/Action";
import Slider from "react-slick";
import ContactModal from "../../model/ContactModal";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserAuth } from "../../../context/AppContext";
import { Link } from "react-router-dom";
// import { MetaTags } from "react-meta-tags";
import BlockchainDevbanImg from "../../../assets/images/blockchain-dev-ban.jpg";
import { Helmet } from "react-helmet";

function Blockchain() {
  const { subActive, setSubActive } = useUserAuth();
  const [commonModal, setCommonModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const routePath = useLocation();
  const location = useLocation();
  const path = location.pathname;
  const scrollToRef = useRef();
  const accuratePath = routePath.pathname;

  useEffect(() => {
    if (accuratePath === "/web-3") {
      window.scroll({
        top: 0,
        behavior: "instant",
      });
    }

    if (
      accuratePath === "/web-3" ||
      accuratePath === "/web-3/blockchain-development" ||
      accuratePath === "/cryptocurrency-development" ||
      accuratePath === "/web-3/smart-contract" ||
      accuratePath === "/web-3/crypto-wallet" ||
      accuratePath === "/web-3/tokenization" ||
      accuratePath === "/web-3/marketplace-development" ||
      accuratePath === "/web-3/trading-bot"
    ) {
      setSubActive(0);
    }
    // eslint-disable-next-line
  }, [accuratePath]);

  useEffect(() => {
    var count = 0;
    var path = routePath.pathname;
    for (var i = 0; i < path.length; i++) {
      if (path[i] === "/") {
        count++;
      }
    }
    if (count > 1) {
      scrollToRef.current.scrollIntoView();
    }
  }, [routePath, subActive]);

  const settings = {
    prevArrow: (
      <button
        type="button"
        className="slick-prev"
        onMouseOver={() => dispatch(increment())}
        onMouseLeave={() => dispatch(decrement())}
      >
        Previous
      </button>
    ),
    nextArrow: (
      <button
        type="button"
        className="slick-next"
        onMouseOver={() => dispatch(increment())}
        onMouseLeave={() => dispatch(decrement())}
      >
        Next
      </button>
    ),
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 499,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>

      {/* <MetaTags>
        <meta
          id="meta-description"
          name="description"
          content="Explore Web 3 innovations with Kindlebit. Take your business to number one position with our modern services now!"
        />
      </MetaTags> */}

      <main className="inner-page" id="services-blockchain">
        <section className="banner dark">
          <img className="banner-img" src={BlockchainDevbanImg} alt="..." />
          <div className="banner-inner container">
            <div className="banner-heading">
              <div className="sap-lg-heading">Web 3</div>
              <div className="text-para">
                Web 3 is the concept of the next generation of web which is
                decentralized, permissionless, has native payments and is
                trustless i.e. it does not require trust of third party
                organizations but rather the trust is based upon the people's
                participation in making transactions possible. All the
                underlying technologies that bind Web 3 are built using
                Blockchain.
              </div>
            </div>
          </div>
        </section>
        <section className="sap-card">
          <div
            className="back-blue-art"
            data-aos="fade-right"
            data-aos-duration="800"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="194.877"
              height="397.823"
              viewBox="0 0 194.877 397.823"
            >
              <g
                id="Group_67"
                data-name="Group 67"
                transform="translate(-2996.562 -104.677)"
              >
                <rect
                  id="Rectangle_90"
                  data-name="Rectangle 90"
                  width="194.877"
                  height="397.823"
                  rx="97.439"
                  transform="translate(2996.562 104.677)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_93"
                  data-name="Rectangle 93"
                  width="117.351"
                  height="318"
                  rx="58.675"
                  transform="translate(3035.325 144.589)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_94"
                  data-name="Rectangle 94"
                  width="55.803"
                  height="237"
                  rx="27.901"
                  transform="translate(3066.099 185.088)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_95"
                  data-name="Rectangle 95"
                  width="16.199"
                  height="175.098"
                  rx="8.099"
                  transform="translate(3085.901 216.039)"
                  fill="#00224b"
                  opacity="0.05"
                />
              </g>
            </svg>
          </div>

          <div
            className="back-orange-art"
            data-aos="fade-left"
            data-aos-duration="800"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="252.883"
              height="123.877"
              viewBox="0 0 252.883 123.877"
            >
              <g
                id="Group_68"
                data-name="Group 68"
                transform="translate(-4187.117 -707.061)"
              >
                <rect
                  id="Rectangle_99"
                  data-name="Rectangle 99"
                  width="123.877"
                  height="252.883"
                  rx="61.939"
                  transform="translate(4440 707.061) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_100"
                  data-name="Rectangle 100"
                  width="74.596"
                  height="202.142"
                  rx="37.298"
                  transform="translate(4414.629 731.702) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_101"
                  data-name="Rectangle 101"
                  width="35.472"
                  height="150.653"
                  rx="17.736"
                  transform="translate(4388.885 751.264) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_102"
                  data-name="Rectangle 102"
                  width="10.297"
                  height="111.304"
                  rx="5.148"
                  transform="translate(4369.21 763.851) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
              </g>
            </svg>
          </div>

          <div className="sap-card-inner container">
            <div className="sec-heading">
              <div className="sap-caption-head">
                <div className="sap-caption">what our services say</div>
              </div>
              <div ref={scrollToRef} className="sap-lg-heading">
                Our services
                <br />
                that we provide
              </div>
            </div>
            <Slider
              {...settings}
              className="services-slider owl-carousel owl-theme"
            >
              <Link to="/web-3/blockchain-development">
                <div
                  className={
                    accuratePath === "/web-3" ||
                      accuratePath === "/cryptocurrency-development" ||
                      accuratePath === "/web-3/blockchain-development"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="8"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg data-name="Layer 1" viewBox="0 0 249.82 256.74">
                      <path
                        fill="#9cb5d4"
                        stroke-width="0"
                        d="M124.15 256.74l-7.45-4.09c-6.93-3.81-14.09-7.75-21.2-11.55-2.11-1.13-2.9-2.44-2.81-4.69.15-3.72.14-7.5-.03-11.23-.05-1.18-.72-2.85-1.87-3.62-9.93-6.74-19.93-13.39-29.73-19.79-.7-.46-1.61-.53-2.08-.53-.75 0-1.49.16-2.02.44-7.1 3.75-14.46 7.74-22.48 12.21-.83.46-1.58.69-2.28.69s-1.41-.21-2.2-.65c-10.24-5.68-19.32-10.64-27.77-15.17-1.6-.86-2.22-1.92-2.21-3.77.05-9.88.05-18.91 0-27.63-.01-1.8.62-2.86 2.26-3.78 4.06-2.29 8.11-4.61 12.15-6.92l.63-.36c4.09-2.34 8.17-4.69 12.28-7 1.66-.93 2.34-2.11 2.33-4.06-.06-12.63-.06-24.9 0-36.47.01-1.92-.69-3.08-2.42-4.01-3.72-1.99-7.42-4.01-11.11-6.03-4.35-2.38-8.85-4.84-13.36-7.23C.73 90.39-.03 89.18 0 87.01c.1-7.93.1-16.47.01-26.88-.02-2.08.64-3.27 2.37-4.24 9.47-5.32 18.63-10.57 27.24-15.61.94-.55 1.79-.82 2.59-.82s1.71.28 2.73.88c10.57 6.2 18.71 10.85 26.38 15.09 2.49 1.38 3.4 2.97 3.15 5.52-.1 1-.08 1.97-.06 3.1.01.58.03 1.15.03 1.77v1.7l1.48-.82.91-.49c.57-.3 1.04-.56 1.49-.84 1.87-1.17 6.51-4.08 6.51-4.08 5.12-3.22 10.39-6.53 15.6-9.72 2.04-1.25 2.31-2.82 2.3-4.34-.04-4.15-.03-8.3-.03-12.45 0-4.55 0-9.25-.04-13.9-.02-2.24.72-3.53 2.64-4.6 9.13-5.09 18.15-10.25 26.82-15.35 1.07-.63 1.97-.92 2.84-.92s1.7.27 2.7.86c8.5 5 17.27 10.02 26.81 15.36 1.96 1.1 2.72 2.38 2.69 4.59-.09 8.37-.09 17.08.02 26.63.02 1.26.69 2.98 1.78 3.69 6.2 4 12.55 7.97 18.71 11.81l4.87 3.04c.2.12.4.22.73.39l.67.33 1.45.74v-1.63-2c0-1.38.02-2.69-.02-4-.06-1.74.61-2.88 2.24-3.8 9.29-5.25 18.68-10.62 27.91-15.96.77-.45 1.46-.66 2.12-.66s1.33.21 2.08.64c8 4.63 16.93 9.75 28.12 16.11 1.4.79 1.96 1.8 1.95 3.46-.04 7.65-.07 17.74.01 27.88.01 1.81-.69 2.9-2.5 3.88-3.74 2.01-7.47 4.04-11.19 6.08-4.46 2.44-9 4.92-13.49 7.31-1.79.96-2.48 2.14-2.47 4.23.08 13.73.08 25.15-.01 35.96-.02 2.17.75 3.46 2.76 4.58 3.86 2.16 7.83 4.45 11.34 6.46l.2.12c4.14 2.37 8.42 4.83 12.66 7.19 2.02 1.13 2.76 2.35 2.73 4.53-.11 8.62-.11 17.41 0 26.88.02 2.09-.71 3.3-2.62 4.32-9.09 4.86-18.21 9.84-27.12 14.79-.89.5-1.7.74-2.46.74s-1.58-.24-2.48-.75c-3.89-2.18-7.88-4.36-11.73-6.46l-.16-.09c-3.36-1.83-6.72-3.67-10.06-5.53-.89-.5-1.61-.72-2.33-.72-.78 0-1.53.26-2.36.82a2426.82 2426.82 0 01-29.07 19.35c-1.71 1.12-2.41 2.49-2.35 4.59.05 1.71.04 3.47.02 5.17v.16c-.01 1.83-.02 3.71.04 5.57.07 2.07-.66 3.28-2.6 4.33-7.19 3.87-14.43 7.84-21.43 11.68l-7.45 4.08h-1.52zm22.11-40.94c-6.06 3.31-11.74 6.41-17.42 9.58-.83.46-1.33 1.62-1.34 2.46-.04 5.24-.04 10.43-.04 15.94v6.12l6.4-3.49c5.68-3.09 11-5.99 16.34-9 1.03-.58 1.71-2.13 1.75-3.24.1-2.89.08-5.81.07-8.63V212.65l-5.75 3.14zm-48.43 3.11c0 5.56-.01 10.8.07 16.14.02 1.34 1.71 2.38 2.05 2.58 2.04 1.17 4.13 2.3 6.16 3.39.93.5 1.83.98 2.73 1.48 2.51 1.37 13.5 7.38 13.5 7.38v-6.21c.01-5.6.02-10.83-.07-16.11-.02-1.16-1.3-2.19-1.98-2.58-3.29-1.87-6.62-3.68-9.86-5.44l-2.13-1.16c-1.71-.93-3.42-1.85-5.22-2.83l-5.27-2.85v6.21zm27.31-24.04c-.81 0-1.64.31-2.16.6-5.92 3.33-11.9 6.77-17.69 10.09l-1.85 1.07c-.33.19-.6.42-.87.66-.13.12-.26.23-.41.34l-1.18.94 5.95 3.25c5.28 2.88 10.74 5.87 16.25 8.81.52.28 1.22.44 1.88.44.52 0 .99-.1 1.35-.3 5.61-2.99 11.1-5.99 16.91-9.17l6.02-3.29-6.01-3.44c-5.58-3.2-11.36-6.52-17.13-9.73-.29-.17-.65-.25-1.07-.25zm-29.39-48.34c-.85 0-1.65.21-2.19.58-9.65 6.66-18.52 12.92-27.12 19.11-1.06.76-1.9 2.46-1.93 3.87-.13 8.92-.1 18.02-.05 25.85 0 .88.46 2.11 1.28 2.67 6.65 4.49 13.3 8.91 20.33 13.59l6.62 4.41v-1.87c0-.53.01-.99.02-1.42.02-1.01.04-1.75-.05-2.52-.32-2.76.61-4.41 3.32-5.88 7.78-4.21 15.54-8.76 23.04-13.15l1.14-.67c1-.59 2.1-2 2.11-3.26.11-8.11.12-16.41 0-25.35-.01-1.1-.9-2.52-1.94-3.1-8.08-4.52-15.57-8.61-22.89-12.48-.45-.24-1.07-.37-1.72-.37zm58.42-.19c-.69 0-1.4.21-2.22.67-7.6 4.22-15.07 8.3-22.19 12.1-1.68.9-2.36 2.07-2.34 4.05.08 8.15.08 16.15 0 23.78-.02 2.12.72 3.4 2.56 4.43 3.9 2.18 7.85 4.44 11.66 6.64l.17.1c3.86 2.22 8.24 4.74 12.58 7.16 2.13 1.19 2.93 2.56 2.74 4.73-.08.95-.06 1.87-.04 2.85v.13c.01.42.02.84.02 1.29v1.13l1.12-.14c.2-.02.34-.03.46-.04.3-.02.59-.04.88-.23l1.97-1.3c7.38-4.89 15-9.95 22.47-14.97.76-.51 1.36-1.67 1.37-2.63.04-7.25.07-16.79-.05-26.36-.02-1.21-.81-2.71-1.82-3.43-4.69-3.36-9.41-6.68-14.12-10l-.52-.36c-4.08-2.87-8.16-5.75-12.22-8.65-.87-.62-1.66-.91-2.47-.91zM53.44 173.89c-5.96 3.25-11.59 6.33-17.24 9.47-.77.43-1.4 1.53-1.41 2.45-.05 5.35-.05 10.79-.04 16.04v6.06l1.48-.8c1.69-.92 3.31-1.86 4.89-2.77 3.57-2.07 6.88-3.98 10.38-5.4 6.54-2.65 8.92-6.68 7.96-13.49-.39-2.78-.3-5.66-.2-8.7.05-1.44.09-2.9.09-4.4v-1.69l-5.91 3.23zm-48.27 2.79c0 5.69 0 11 .05 16.36.01 1.05.99 1.99 1.61 2.33 5.38 2.99 10.78 5.94 16.41 9.02l6.4 3.5v-6.24c.01-5.59.02-10.82-.06-16.09-.02-1.17-1.3-2.21-1.97-2.6-2.03-1.18-4.13-2.31-6.16-3.4-.87-.47-1.69-.91-2.52-1.36l-13.76-7.51v5.99zm237.94-4.86c-.09 0-.36 0-.64.15l-1.6.87c-5.92 3.21-12.63 6.84-19.06 10.39-.76.42-1.56 1.42-1.56 2.35-.05 5.29-.05 10.54-.05 16.09v6.22l5.24-2.86c6.08-3.31 11.95-6.52 17.81-9.76.66-.37 1.38-1.32 1.39-2.23.04-5.44.04-10.95.04-16.29v-4.91h-1c-.12 0-.21 0-.29-.01-.11 0-.19-.01-.26-.01zm-52.63.74c0 1.48.05 2.94.09 4.35.1 3.14.2 6.08-.2 8.93-.91 6.4 1.38 10.25 7.66 12.9 3.6 1.51 7 3.46 10.59 5.53 1.65.95 3.29 1.89 4.98 2.81l1.48.8v-6.33c.01-5.53.02-10.69-.07-15.91-.02-1.22-1.37-2.3-2.16-2.74-5.57-3.1-11.18-6.15-16.6-9.09l-2.26-1.23c-.4-.22-.82-.39-1.29-.58-.25-.1-.51-.21-.81-.34l-1.4-.6v1.52zm-158.14-19.5c-.79 0-1.61.19-2.2.51-4.59 2.52-9.17 5.16-13.6 7.7l-3.56 2.04c-.73.42-1.45.85-2.24 1.33l-2.86 1.71 6.28 3.43c5.67 3.09 11.02 6.02 16.47 8.94.46.25 1.09.39 1.69.39.36 0 .88-.05 1.33-.3 5.74-3.08 11.5-6.23 17.07-9.28l5.9-3.23-6.39-3.66c-5.58-3.2-10.84-6.22-16.22-9.2-.57-.31-1.23-.38-1.69-.38zm185.42 0c-.79 0-1.63.2-2.24.52-3.03 1.62-6.05 3.37-8.97 5.05-1 .58-13.32 7.68-13.32 7.68l6.25 3.41c5.69 3.11 11.07 6.04 16.54 8.97.48.26 1.11.41 1.73.41.34 0 .85-.05 1.29-.29 5.53-2.96 10.97-5.93 16.72-9.08l6.29-3.44-6.58-3.77c-5.53-3.17-10.75-6.16-16.08-9.1-.55-.3-1.19-.37-1.63-.37zM59.16 93.28c-.67 0-1.33.2-2.09.62-6.35 3.56-12.88 7.12-19.97 10.9-1.71.91-2.41 2.08-2.4 4.02.06 10.88.06 22.81 0 36.48 0 1.88.63 3 2.2 3.88 7.72 4.32 15.25 8.64 22.38 12.83.77.45 1.45.66 2.14.66.82 0 1.58-.29 2.53-.97 3.7-2.64 7.42-5.26 11.14-7.87l.27-.19c5.01-3.53 10.19-7.18 15.25-10.82 1.08-.78 1.94-2.41 2.02-3.8.14-2.64.12-5.32.1-7.92 0-1.02-.02-2.02-.02-3.03s0-2.03.02-3.05c.02-2.66.05-5.42-.1-8.15-.07-1.38-.99-3.04-2.09-3.77-5.83-3.87-11.94-7.85-17.33-11.36-3.9-2.54-7.81-5.08-11.7-7.64-.86-.57-1.59-.82-2.35-.82zm131.59.15c-.77 0-1.51.19-2.02.51-9.68 6.2-19.68 12.71-29.72 19.34-1 .66-1.82 2.09-1.83 3.19-.1 7.43-.1 15.11 0 22.83.01 1.14.76 2.57 1.71 3.24 9.23 6.61 18.5 13.14 27.55 19.41.51.35 1.25.55 2.05.55.62 0 1.2-.13 1.63-.37 8.28-4.62 15.75-8.9 22.86-13.1 1.08-.64 2.02-2.26 2.05-3.55.1-4.72.09-9.64.08-13.98v-4.54-4.5c.01-4.5.02-9.15-.07-13.76-.02-1.22-.81-2.96-1.94-3.6-6.26-3.56-13.02-7.26-20.67-11.32-.44-.23-1.03-.36-1.66-.36zM146 120.66c-5.94 3.24-11.54 6.31-17.16 9.46-1.04.58-1.34 2.18-1.35 2.94-.05 3.6-.05 7.25-.04 10.79v10.78l6.15-3.36c5.75-3.14 11.16-6.09 16.58-9.12.84-.47 1.74-1.69 1.75-2.76.07-5.08.07-10.15.06-15.52v-6.49l-6 3.28zm-48.18 3.13c0 5.53-.02 10.68.08 15.85.02 1.23 1.38 2.31 2.17 2.76 4.65 2.6 9.41 5.19 14.01 7.69l3.53 1.92c.67.36 1.34.71 2.09 1.11l2.66 1.4v-6.17c0-5.14.01-10.46-.04-15.69 0-.88-.57-2.15-1.47-2.65-5.69-3.18-11.5-6.35-17.13-9.43l-5.9-3.22v6.43zm27.08-23.62c-1.96 0-3.9.7-6.1 2.21-3.61 2.49-7.42 4.58-11.46 6.8-1.75.96-3.51 1.93-5.28 2.94l-1.55.89 6.14 3.36c5.77 3.16 11.22 6.14 16.8 9.12.49.26 1.04.32 1.42.32.59 0 1.17-.13 1.6-.36 5.53-2.96 10.98-5.94 16.75-9.09l6.11-3.34-1.55-.89c-1.78-1.02-3.55-2-5.3-2.96-3.99-2.2-7.76-4.29-11.35-6.72-2.29-1.55-4.27-2.27-6.25-2.27zm27.28-46.54c-.68 0-1.36.2-2.13.63-6.73 3.76-13.6 7.5-20.41 11.13-1.59.85-2.23 1.97-2.22 3.87.07 7.65.07 15.31 0 22.77-.02 1.86.62 2.98 2.2 3.87 7.31 4.1 14.7 8.33 22.59 12.94.79.46 1.48.68 2.16.68.74 0 1.47-.25 2.29-.8 1.39-.92 2.78-1.85 4.18-2.78 5.81-3.88 11.8-7.88 17.86-11.48 4.28-2.53 8.67-5.8 6.67-12.48 0-.5-.01-1-.02-1.5-.03-1.19-.05-2.42.05-3.58.19-2.1-.59-3.52-2.6-4.76-8.24-5.07-17.23-10.7-28.29-17.71-.84-.54-1.58-.78-2.34-.78zm-54.53.25c-.8 0-1.53.18-2.05.5-9.73 5.96-19.54 12.1-29.17 18.26-1.13.72-1.86 2.4-1.91 3.61-.16 3.63-.16 7.48 0 11.47.05 1.26.83 2.75 1.79 3.38 8.98 5.96 18.12 11.9 27.16 17.66.53.33 1.29.53 2.09.53.69 0 1.33-.14 1.8-.41 4.25-2.36 8.65-4.88 12.53-7.1 3.44-1.97 6.88-3.94 10.34-5.88 1.57-.88 2.23-2.05 2.18-3.9-.06-2.72-.05-5.47-.04-8.13v-3.24-3.23c-.01-2.67-.02-5.42.04-8.14.04-1.88-.62-3.04-2.21-3.89-3.07-1.63-6.12-3.3-9.17-4.96-3.48-1.9-7.42-4.05-11.31-6.09-.54-.29-1.3-.45-2.06-.45zm-40 10.35c-.21 0-.41.05-.58.15l-2.53 1.37c-6 3.24-12.2 6.59-18.3 10-1 .56-1.42 2.06-1.45 2.87-.08 2.19-.06 4.39-.05 6.52v15.18l1.48-.81c1.68-.92 3.32-1.86 4.9-2.77l.14-.08c3.63-2.09 7.03-4.06 10.62-5.55 6.17-2.57 8.44-6.36 7.57-12.67-.4-2.93-.3-6.01-.2-8.99v-.12c.05-1.31.09-2.67.09-3.99v-.9l-.89-.1c-.15-.02-.27-.04-.36-.05-.2-.04-.33-.05-.44-.05zm132.83 5.38c0 5.4-.02 10.45.08 15.49.03 1.26 1.36 2.49 2.19 2.97 3.42 1.96 6.91 3.85 10.29 5.68l2.78 1.51c1.71.93 3.42 1.85 5.24 2.83l4.02 2.17v-1.68c0-1.57-.04-3.11-.09-4.61-.09-3.25-.18-6.32.19-9.31.75-6.03-1.43-9.78-7.09-12.16-3.71-1.56-7.23-3.58-10.95-5.71-1.69-.97-3.41-1.96-5.19-2.92l-1.48-.8v6.54zM5.29 64.82l-.06 1.11c-.04.66-.07 1.21-.07 1.76 0 1.67 0 3.34.01 5.01.02 3.65.03 7.42-.06 11.15-.06 2.22.76 3.55 2.81 4.59 2.64 1.34 5.28 2.8 7.83 4.22 1.16.64 2.31 1.28 3.46 1.91 1.85 1.01 9.7 5.26 9.7 5.26l.74.4v-6.26c.01-5.56.02-10.75-.06-15.99-.02-1.19-1.27-2.22-1.93-2.6-3.3-1.88-6.77-3.77-9.83-5.43l-1.69-.92c-1.92-1.04-3.84-2.08-5.85-3.16l-4.9-2.64-.08 1.58zm237.73-.59c-.21 0-.41.05-.58.15-6.09 3.3-13.68 7.41-20.84 11.37-.65.36-1.36 1.3-1.37 2.2-.04 5.58-.04 11.3-.04 16.34v4.54l.74.2c.08.02.14.04.19.06.15.05.3.1.49.1h.23l.24-.11 2.07-1.11c5.88-3.15 12.54-6.72 19.06-10.28.67-.37 1.4-1.32 1.41-2.23.05-5.46.04-10.99.04-16.33v-4.69l-.88-.1c-.13-.01-.24-.04-.32-.05-.18-.04-.33-.05-.44-.05zM32.27 45.94c-2.25 0-4.47.83-7 2.61-3.36 2.36-6.95 4.33-10.76 6.41-1.72.94-3.43 1.88-5.14 2.86l-1.55.89 5.93 3.23c5.58 3.05 11.36 6.2 17.07 9.26.39.21.9.32 1.43.32.5 0 .98-.11 1.35-.3 5.75-3.08 11.55-6.25 17.17-9.31l5.74-3.13-2.43-1.51c-.6-.38-1.12-.7-1.64-1-1.39-.8-2.82-1.57-4.24-2.33-3.05-1.64-6.21-3.34-9-5.38-2.43-1.77-4.7-2.63-6.93-2.63zm185.45-.75c-.53 0-1.08.13-1.49.37-5.68 3.21-11.35 6.46-17.23 9.83l-5.79 3.32 6.82 3.73c5.45 2.98 10.6 5.8 15.86 8.58.57.3 1.23.37 1.68.37.71 0 1.43-.16 1.97-.43 3.28-1.69 6.56-3.5 9.74-5.25l12.75-7.01-5.75-3.29c-6.02-3.45-11.7-6.7-17.47-9.95-.29-.17-.67-.25-1.09-.25zm-71.91-18.21c-5.84 3.18-11.35 6.19-16.89 9.31-1.09.61-1.4 2.33-1.42 3.15-.06 3.32-.06 6.69-.05 9.95v11.42l5.98-3.26c5.52-3.01 11.23-6.12 16.81-9.22.83-.46 1.69-1.54 1.7-2.55.07-5.22.06-10.41.06-15.91V23.6l-6.2 3.38zM97.97 25.3c-.02.41-.05.78-.07 1.12-.04.67-.08 1.22-.08 1.76 0 1.36.02 2.73.05 4.1v.14c.06 3 .12 6.1-.13 9.1-.36 4.29 1.17 6.91 5.09 8.75 4.21 1.99 8.25 4.25 12.52 6.64 1.83 1.03 3.67 2.06 5.55 3.08l1.48.8V54.6c0-5.52.02-10.74-.06-16.08-.02-1.2-1.27-2.23-1.93-2.6-2.72-1.55-5.52-3.07-8.22-4.54l-14.09-7.67-.08 1.58zm27-19.54c-.55 0-1.09.13-1.48.35-5.81 3.27-11.57 6.58-17.13 9.77l-5.84 3.35 6.3 3.44c5.73 3.14 11.08 6.06 16.53 8.97.42.22.97.34 1.55.34.61 0 1.22-.14 1.67-.38 5.5-2.93 11.06-5.97 16.44-8.91l5.31-2.9-.49-.88-.05-.09c-.08-.17-.21-.44-.52-.62l-2.71-1.58c-5.63-3.28-12-6.99-18.26-10.56-.45-.25-.96-.31-1.32-.31z"
                      />
                    </svg>
                  </div>
                  <div className="wdi-heading">Blockchain Development</div>
                </div>
              </Link>
              <Link to="/web-3/smart-contract">
                <div
                  className={
                    accuratePath === "/web-3/smart-contract"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="8"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg data-name="Layer 1" viewBox="0 0 296.01 218.17">
                      <path
                        fill="#9cb5d4"
                        stroke-width="0"
                        d="M282.63 218.17c-2.32 0-4.64-.62-6.69-1.8-5-2.86-7.53-8.95-6.15-14.8.72-3.03.04-5.29-2.19-7.34-1.03-.94-1.99-2.05-3.01-3.22-2.09-2.4-4.26-4.88-7.18-6.09-1.61-.67-3.47-.98-5.84-.98-1.37 0-2.77.1-4.12.2-1.34.1-2.6.19-3.82.19H227.6v5.84c0 4.1-.01 7.07-.75 7.8-.75.74-3.76.74-7.92.74H82.31c-3.64-.02-4.28-.66-4.3-4.3-.02-5.42-.02-10.84-.01-16.26v-8.16l-1.21-.52c-.95-.41-1.83-.61-2.68-.61-2.22 0-3.67 1.35-4.57 2.37l-.88 1.01c-3.46 3.94-4.71 5.31-5.79 5.31-.84 0-2.3-.62-4.32-1.48-1.04-.44-2.26-.96-3.71-1.53-2.33-.92-4.64-1.87-6.96-2.82-3.05-1.25-6.2-2.55-9.34-3.75-3.28-1.25-2.9-2.85-2.69-3.71 1.86-7.82-1.98-12.82-6.41-17.06-2.79-2.67-6.33-5.41-11.44-5.41-.94 0-1.92.09-2.94.27-.79.14-1.42.21-1.94.21-1.31 0-1.96-.14-3.38-3.53-.87-2.08-1.74-4.15-2.61-6.23-2.06-4.95-4.19-10.07-6.4-15.07-1.35-3.05-.32-4.23.98-5.04 6.03-3.76 7.24-9.03 7.22-15.78-.02-5.13-.85-10.45-6.72-14.67C-.48 80.02-.54 79.74.97 76.1c.9-2.17 1.8-4.33 2.7-6.5 2.03-4.86 4.12-9.89 6.12-14.87 1.12-2.78 2.42-2.78 2.91-2.78.27 0 .56.04.88.11 1.33.31 2.63.47 3.87.47 5.84 0 9.94-3.52 13.17-6.96 3.64-3.87 5.92-7.68 5.22-13.67q-.51-4.39 4.2-6.36c2.26-.94 4.52-1.87 6.79-2.8 4.4-1.81 8.96-3.69 13.42-5.61.85-.37 1.6-.55 2.23-.55.7 0 1.64.18 2.79 1.62 1.38 1.71 2.74 3.41 4.44 4.82 1.03.86 2.25 1.39 3.32 1.85.42.18.84.36 1.24.56l1.35.67 2.34-2.56.03-.81v-5.4V4.88c.01-4.31.5-4.81 4.7-4.81h40.38c18.91 0 39.21 0 59.54-.06 2.31 0 3.92.7 5.59 2.4 13.24 13.51 25.52 25.91 37.54 37.93 1.51 1.51 2.04 2.82 1.88 4.66-.16 1.85-.12 3.64-.08 5.55.02.82.03 1.65.03 2.51v2h13.27c4.51 0 9.84 0 15.23-.06 1.55-.02 2.77-1.2 3.58-1.99 1.08-1.04 2.13-2.12 3.18-3.18 1.51-1.53 3.07-3.12 4.67-4.58 2.34-2.15 2.95-4.35 2.05-7.37-2.07-6.94 2.01-14.32 9.1-16.45 1.19-.36 2.42-.54 3.66-.54 5.66 0 10.71 3.71 12.56 9.23 1.68 5.02.6 9.61-3.22 13.62-2.58 2.7-5.57 4.07-8.91 4.07-1.45 0-2.98-.26-4.55-.77-.81-.26-1.53-.39-2.2-.39-1.92 0-3.18 1.07-4.06 2-1.61 1.7-3.31 3.38-4.96 5.01-1.66 1.64-3.38 3.34-5.02 5.07-1.4 1.47-2.89 2.1-5 2.1h-.1c-3.41-.04-6.83-.05-10.24-.05-2.2 0-11.01.02-13.22.02h-5.59v25.21h14.72c.58 0 1.05.02 1.46.05 1.78.15 2.96 1.23 3 2.75.04 1.61-1.18 2.78-2.98 2.85-1.31.05-2.74.08-4.5.08-.99 0-1.97 0-2.96-.01-1 0-1.99-.01-2.99-.01h-5.79v25.35l1.91.09 1.09.06c.76.04 1.55.09 2.34.09h16.46c4-.01 9.28 0 14.67.06h.17c3.12 0 4.95-1.11 6.35-3.84 2.2-4.32 6.67-7 11.66-7 1.2 0 2.41.16 3.58.47 5.64 1.49 9.72 6.79 9.7 12.61-.02 6.34-4.4 11.98-10.4 13.42-1.07.26-2.15.39-3.22.39-4.84 0-9.21-2.73-11.7-7.29-.18-.33-1.81-3.19-4.16-3.22-7.75-.09-15.54-.1-22.14-.1h-16.21v25.41h15.75c2.04 0 3 .72 3.35 2.48.17.86-.15 1.49-.45 1.86-.55.69-1.47 1.09-2.52 1.11-1.85.04-3.69.05-5.56.05-1.37 0-2.75 0-4.15-.01-1.44 0-2.9-.01-4.39-.01h-2v24.9l1.89.1.91.06c.75.05 1.53.11 2.35.11h4.72c2.9.02 5.8.03 8.7.03 3.55 0 7.11-.01 10.66-.05h.11c2.01 0 3.42.58 4.71 1.95 1.59 1.69 3.26 3.33 4.87 4.92 1.7 1.67 3.45 3.41 5.09 5.16.81.87 2.12 2.03 4.11 2.03.75 0 1.54-.16 2.49-.49 1.39-.49 2.83-.74 4.27-.74 4.45 0 8.59 2.35 11.06 6.29 3.43 5.48 2.82 11.69-1.6 16.21-2.57 2.63-5.97 4.08-9.59 4.08zm-.05-20.81c-2.09 0-4.05.81-5.52 2.29a7.698 7.698 0 00-2.26 5.49c.01 4.28 3.04 7.31 7.37 7.37h.12c4.38 0 7.58-3.11 7.61-7.4.03-4.14-3.27-7.68-7.2-7.74h-.12zm-198.79-4.38h138V46.04h-35.17c-4.26 0-5.01-.75-5.02-4.98-.01-5.56-.01-11.12-.01-16.68V11.15c0-.81-.06-1.6-.12-2.36-.03-.33-.05-.67-.07-1l-.11-1.88H83.8v187.07zm-61.65-57.27c3.08 0 5.57 1.32 7.62 4.04 1.97 2.61 4.45 4.81 6.38 6.44 4.39 3.68 7.03 7.27 5.64 12.8-.43 1.7.79 4.25 2.37 4.95 4.14 1.84 8.24 3.52 12.59 5.29 1.32.54 5.38 2.21 5.38 2.21l1.68-2.15c2.74-3.52 5.11-6.57 8.86-6.57.76 0 1.59.12 2.46.37l2.54.72v-23.35l-1.56-.35c-.38-.09-.75-.18-1.12-.26-.81-.2-1.57-.38-2.37-.52-18.65-3.3-34-20.63-34.94-39.46-1.12-22.39 14.17-41.54 36.35-45.54 1.77-.32 3.62-2.4 3.68-4.12.13-4.28.12-8.6.1-13.17v-7.32l-2.57.76c-.96.29-1.87.43-2.71.43-3.26 0-5.45-2.13-8.13-5.81-.96-1.32-2.14-1.99-3.51-1.99-.71 0-1.44.18-2.29.56-2.51 1.13-5.12 2.21-7.64 3.24-1.02.42-2.04.84-3.05 1.26-6.34 2.65-6.89 3.61-6.02 10.29.3 2.3-.26 3.87-1.93 5.42l-.31.29c-2.63 2.43-5.34 4.94-7.69 7.76-3.73 4.48-6.92 6.39-10.67 6.39-.92 0-1.9-.12-2.91-.36a3.38 3.38 0 00-.72-.08c-1.25 0-3.34.81-4.01 2.33-1.87 4.26-3.64 8.61-5.36 12.83l-2.09 5.11 1.08.94c.52.46 1.01.9 1.48 1.32 1.03.93 2 1.81 3.07 2.62 2.1 1.59 2.91 3.38 2.73 5.97-.16 2.19-.12 4.38-.09 6.5.02 1.26.04 2.53.02 3.79-.03 2.12 0 3.75.01 5.06.03 2.16.05 3.35-.25 4.01-.3.67-1.24 1.49-2.93 2.97-.95.83-2.13 1.86-3.59 3.21-.34.32-.52.65-.65.9-.03.06-.07.14-.12.22l-.51.86.38.93c.57 1.38 1.16 2.76 1.75 4.15 1.4 3.31 2.85 6.73 4.1 10.15.48 1.32 1.62 4.42 5.31 4.42.5 0 1.02-.05 1.6-.17.89-.18 1.75-.27 2.56-.27zm53.18-75.84c-19.18 2.67-33.13 20.14-31.77 39.77 1.2 17.2 16.76 33.56 32.03 33.67h2.01V59.55l-2.28.32zm206.97 52.46c-4.1 0-7.47 3.38-7.51 7.53-.02 2.11.73 4.05 2.13 5.46 1.38 1.4 3.28 2.16 5.34 2.16 1.98-.02 3.88-.87 5.32-2.34 1.42-1.45 2.22-3.35 2.2-5.21-.05-4.14-3.23-7.48-7.24-7.61h-.23zm.06-85.4c-4.3 0-7.46 3-7.53 7.15-.03 1.98.73 3.84 2.14 5.26 1.4 1.4 3.26 2.19 5.26 2.22h.14c4.29 0 7.38-2.91 7.52-7.08.06-1.95-.64-3.8-1.98-5.21-1.39-1.46-3.3-2.29-5.37-2.33h-.18zm-94.66 13.09h28.38l-28.38-28.45v28.45zm-73.25 131.5c-1.85 0-3.7-.01-5.55-.05-1.21-.03-3.25-.44-3.38-2.9-.03-.6.27-1.29.79-1.85.64-.68 1.53-1.08 2.43-1.09 3.45-.03 6.89-.05 10.34-.05 5.98 0 11.92.05 17.65.15.93.02 1.7.32 2.23.89.52.55.79 1.33.75 2.2-.07 1.7-1.13 2.58-3.15 2.61-1.85.03-3.7.04-5.55.04h-10.29v.05h-2.15c-1.38 0-2.75.01-4.13.01zm50.6-.05c-2.63 0-5.27 0-7.9-.03-3.58-.03-3.62-1.83-3.64-2.7-.02-.93.21-1.64.68-2.12.58-.6 1.59-.92 2.93-.93 6.43-.03 12.86-.04 19.28-.04s13.18.02 19.77.04c1.3 0 2.39.39 3.05 1.07.49.51.73 1.16.71 1.93-.08 2.36-2.37 2.73-3.73 2.75-2.69.02-5.37.03-8.06.03h-23.07zm21.94-24.15c-.77 0-1.54 0-2.31-.04-1.71-.07-2.87-1.12-2.96-2.68-.05-.8.22-1.59.74-2.16.35-.38.97-.85 1.96-.89 2.05-.09 4.15-.13 6.25-.13s4.33.04 6.52.13c1.63.07 2.72 1.55 2.72 2.89 0 1.55-1.31 2.75-3.1 2.86h-6.05c-.71 0-1.33 0-1.95.01-.61 0-1.22.01-1.82.01zm-77.39-.02c-1.17 0-3.92-.28-4.03-2.81-.03-.69.21-1.3.71-1.82.74-.77 1.96-1.21 3.34-1.21h12.33c14.05 0 28.1 0 42.15.03 4.04 0 4.04 2 4.04 2.95 0 1.07 0 2.86-4.06 2.87h-54.48zm5.88-24.15c-2 0-3.99-.01-5.99-.04-2.24-.03-3.89-1.32-3.93-3.08-.04-1.74 1.55-3.03 3.86-3.12 1.04-.04 2.15-.06 3.5-.06.94 0 1.87 0 2.81.02h.85v.02l2 .08c.89 0 1.78 0 2.67-.02.88 0 1.75-.02 2.63-.02 1.09 0 2.17.01 3.26.05 2.33.08 3.92 1.33 3.88 3.04-.04 1.71-1.54 2.91-3.74 2.97-3.75.1-7.73.16-11.81.16zm36.24-.04c-1.55 0-3.19-.03-4.75-.28-1.88-.3-2.68-1.22-2.62-3 .06-1.65 1.11-2.68 2.83-2.76 2.57-.12 5.1-.13 7.03-.13 1.09 0 2.19 0 3.28.01 1.1 0 2.2.01 3.3.01H170.34v.16h25.43c2.57 0 3.32.6 3.82 1.69.37.82.37 1.68 0 2.44-.38.75-1.06 1.26-1.94 1.45-.79.17-1.71.19-2.66.2-14.28.09-28.56.17-42.83.22h-.45zm-6.45-24.56c-6.18 0-12.35 0-18.53-.02-1.98 0-3.22-1.27-3.24-3.3-.1-11.19-.09-22.38.05-33.23.02-2.01.61-3.2 3.52-3.29.4-.01.79-.02 1.21-.02h2.5l2.17.01-.18-2.17c-.76-9.06 1.58-15.5 7.36-20.27 3.64-3 7.8-4.52 12.36-4.52h.52c6.33.16 11.57 2.75 15.55 7.7 4.08 5.06 4.54 11.28 4.42 17.24l-.04 2.04h4.56c.45-.01.88 0 1.31 0 2.43.07 3.38 1.02 3.39 3.37.06 11.27.06 22.35 0 32.95-.01 2.23-1.2 3.42-3.42 3.43-11.17.04-22.35.06-33.52.06zm-15.8-6.07h46.3v-27.7h-46.3v27.7zm23.41-54.66c-2.56 0-5.12.79-7.6 2.33-6.75 4.2-6.82 10.74-6 16.58l.24 1.72h27.13l.14-1.85c.44-5.84.03-12.36-6.36-16.44-2.44-1.56-4.99-2.35-7.55-2.35z"
                      />
                    </svg>
                  </div>
                  <div className="wdi-heading">Smart Contract</div>
                </div>
              </Link>
              <Link to="/web-3/crypto-wallet">
                <div
                  className={
                    accuratePath === "/web-3/crypto-wallet"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="8"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg data-name="Layer 1" viewBox="0 0 266.02 296">
                      <path
                        fill="#9cb5d4"
                        stroke-width="0"
                        d="M117.37 296c-21.2 0-42.38-.01-63.58-.04-14.72-.02-28.32-5.53-38.3-15.52C5.52 270.46.03 256.84.02 242.11-.01 187.82 0 132.69.02 79.38c0-14.52 9.74-24.3 24.23-24.34.93 0 1.86-.02 2.79-.03 1.03-.01 2.06-.03 3.08-.03 1.55 0 2.82.03 3.99.11.2.01.39.02.57.02 3.29 0 4.5-2.11 5.19-3.96 7.29-19.51 20.41-34.04 38.99-43.18C89.6 2.68 101.07 0 112.94 0c32.36 0 61.71 20.37 73.04 50.7 1.18 3.17 2.93 4.4 6.24 4.41 24.91.02 43.72 18.89 43.77 43.9.01 5.42 0 10.85 0 16.39v9.62H247.18c11.21.06 18.77 7.66 18.79 18.91.04 17.51.04 33.24 0 48.09-.04 15.97-10.86 27.6-26.92 28.96-.26.02-.52.07-.89.15-.15.03-.33.07-.55.11l-1.63.31v20.59c-.08 30.65-23.21 53.79-53.81 53.83-21.6.03-43.21.04-64.82.04zM6.02 218.17c0 2.74 0 5.45-.02 8.16-.02 5.77-.04 11.74.04 17.59.32 25.24 20.91 45.86 45.9 45.97 20.5.09 42.04.14 64.02.14s44.15-.04 68.17-.13c21.33-.08 40.41-15.62 44.36-36.16 1.32-6.87 1.52-14.05 1.71-20.99.09-3.16.18-6.43.37-9.65l.13-2.12h-6.03c-2.91 0-5.82.01-8.73.02-2.9.01-5.81.03-8.71.03-5.13 0-9.3-.04-13.14-.13-4.23-.1-7.97-.64-11.11-1.61-14.91-4.63-24.92-19.99-22.79-34.96 2.42-17.01 15.74-29.05 32.4-29.3 3.71-.05 7.7-.08 12.56-.08 3.15 0 6.29 0 9.44.02 3.15.01 6.3.02 9.45.02h5.9v-2c0-.85.01-1.66.02-2.45.02-1.78.05-3.46-.06-5.15-.15-2.42-.45-4.7-.89-6.79-4.79-22.46-23.48-37.56-46.52-37.58-27.92-.02-55.84-.03-83.76-.03-25.1 0-50.19 0-75.29.02-4.86 0-8.98-1.09-12.63-3.33-.54-.33-1.08-.5-1.52-.63-.12-.04-.24-.07-.36-.11l-2.69-.99v73.88H55v-8.92-16.29c0-3.83.77-4.6 4.51-4.61h7.35c3.66-.02 7.33-.03 10.99-.03 6.62 0 12.01.03 16.95.09h.23c2.89 0 5.13-.74 6.66-4.37 2.74-6.5 9.11-10.69 16.25-10.69 3.03 0 6.05.78 8.75 2.25 4.32 2.36 7.5 6.48 8.73 11.31 1.23 4.85.39 10.02-2.3 14.18-3.37 5.2-9.03 8.31-15.15 8.31-3.9 0-7.56-1.29-10.58-3.73-2.05-1.66-3.76-4.01-5.57-6.5-.92-1.27-1.87-2.58-2.94-3.9l-.6-.75H61.01v24.91c0 4.21-.69 4.9-4.86 4.9H6.16v13.85h93.55l.54-1.16c4.22-9.1 10.04-13.71 17.28-13.71 1.4 0 2.87.17 4.38.51 8.24 1.83 14.03 8.97 14.08 17.37.05 8.54-5.74 15.8-14.08 17.66-1.51.34-2.99.51-4.38.51-7.2 0-13.02-4.61-17.28-13.71l-.54-1.15H6.21V210H56.47c3.75 0 4.51.78 4.53 4.6v20.3h38.83l1.35-3.32c2.8-6.94 9.49-11.61 16.66-11.61 1.05 0 2.11.1 3.15.3 8.76 1.69 14.92 8.89 14.99 17.52.07 8.78-6.05 16.14-14.9 17.89-1.07.21-2.17.32-3.26.32-7.17 0-13.81-4.63-16.54-11.52-.98-2.48-2.52-3.53-5.16-3.53-6.33.04-12.58.05-18.84.05-3.81 0-17.46-.01-17.46-.01-4.13 0-4.81-.7-4.82-4.94v-6.15c0-3.16 0-6.32-.01-9.48 0-.67-.08-1.3-.16-1.85-.03-.21-.05-.41-.07-.6l-.18-1.8H6.02v2zm111.88 7.84c-6.53.06-11.86 5.44-11.88 11.98-.02 6.47 5.43 11.96 11.91 11.98 3.29 0 6.33-1.28 8.61-3.6 2.28-2.31 3.5-5.36 3.45-8.58-.11-6.5-5.48-11.78-11.97-11.78h-.12zm91.91-65.02c-7.03 0-12.42.03-17.49.08-14.42.16-26.22 12.14-26.31 26.72-.09 14.71 11.53 26.87 25.9 27.12 7.25.12 14.65.18 22.63.18 7.56 0 15.5-.05 24.27-.17 11.21-.14 20.65-9.25 21.03-20.3.27-7.91.21-15.82.14-23.48-.03-3.27-.05-6.5-.05-9.67v-2.24l-2.23.25c-1.51.17-3 .38-4.46.59-3.04.43-5.92.84-8.77.87-4.76.05-9.79.07-16.33.07h-18.35zm-91.86 20.03c-3.24.02-6.26 1.31-8.53 3.64a11.906 11.906 0 00-3.4 8.66c.15 6.43 5.52 11.66 11.97 11.66h.26c6.55-.15 11.82-5.59 11.74-12.13-.08-6.52-5.45-11.83-11.97-11.83h-.07zm118.25-26.05h2c1.15 0 2.28.02 3.4.04s2.22.04 3.32.04c1.6 0 2.92-.04 4.16-.13 6.15-.43 11.04-5.9 10.9-12.19-.14-6.27-5.16-11.4-11.43-11.67-1.16-.05-2.39-.07-3.89-.07-1.03 0-2.07.01-3.13.02-1.09.01-2.19.02-3.33.02h-2v23.94zm-118.33-23.93c-6.53.08-11.85 5.46-11.85 12.01 0 6.47 5.46 11.95 11.94 11.96 6.56 0 11.95-5.31 12.03-11.84.04-3.21-1.19-6.25-3.47-8.55-2.28-2.3-5.29-3.57-8.5-3.57h-.14zm74.45-69.96l-1.97.03v34.32l1.64.3c14.02 2.57 25.28 9.69 34.4 21.76l3.6 4.76v-5.96c0-2.14 0-4.2.02-6.19.02-4.27.03-8.31-.03-12.34-.16-9.87-3.64-18.39-10.36-25.32-7.31-7.54-16.26-11.37-26.6-11.37h-.69zm-165.96-.07c-1.8 0-3.3.04-4.71.12-7.9.48-14.58 6.9-15.54 14.95-1.01 8.43 4.01 16.34 11.42 18 3.85.86 7.73.95 11.49 1.04 1.57.04 3.05.07 4.48.16l2.12.13V61.08h-2c-1.14 0-2.31-.02-3.49-.04-1.24-.02-2.5-.04-3.78-.04zm86.68-34.91c-3.83 0-7.71.42-11.54 1.25-13.38 2.9-25.29 11.42-32.68 23.37-7.42 12-9.73 26.55-6.32 39.91.53 2.08 1.63 4.47 5.46 4.47h.27c2.73-.07 5.72-.1 9.39-.1 2.01 0 4.03 0 6.04.02 2.02 0 4.04.02 6.06.02h10.14v-39h-2c-.56 0-1.09 0-1.6.01-.46 0-.91.01-1.35.01-.53 0-1.04 0-1.55-.03-2.08-.1-3.36-1.25-3.34-3 .01-1.78 1.28-2.88 3.39-2.96.8-.03 1.6-.04 2.4-.04.66 0 1.32 0 1.98.01.67 0 1.33.01 1.98.01h1.85l.14-1.84c.47-5.96 1.75-6.03 2.88-6.09h.19c.57 0 1.05.11 1.28.19.78 1.29 1.4 2.74 2.05 4.28.29.68.58 1.37.89 2.06l.53 1.18h8.25l.09-1.91c.02-.47 0-.93-.02-1.37-.02-.36-.04-.9.01-1.07l.04-.06c.64-1.14 1.52-2.71 2.36-3.12.35-.17.69-.26 1.03-.26.71 0 1.24.38 1.56.7.67.67 1.05 1.71 1.05 2.86 0 2.41.48 4.87 3.98 6.53 3.88 1.84 6.43 5.17 7.57 9.89 1.27 5.22-.07 9.92-4.21 14.81l-1.17 1.38 1.25 1.3c3.4 3.54 4.91 7.93 4.6 13.44l-.12 2.11h11.82c3.3.01 7.22 0 11.27-.08 1.7-.04 3.73-1.72 4.09-3.39l.21-.95c.73-3.28 1.48-6.68 1.61-10.14.57-14.54-4.55-28.2-14.42-38.46-9.86-10.25-23.15-15.9-37.43-15.9zm-6.91 68.93h17.6c3.04 0 5.05-.89 6-2.63.93-1.72.59-3.85-1.01-6.32-1.33-2.04-3.98-4.4-6.67-4.74-1.75-.22-3.64-.32-5.98-.32-1.32 0-2.65.03-3.99.06-1.31.03-2.63.06-3.96.06h-2v13.89zm6.91-88.89c-16.63 0-32.73 5.66-45.33 15.94-24.1 19.66-30.64 50.81-24.65 71.41l.42 1.44h13.79l-.55-2.44c-6.55-29.2 7.17-50.78 22.19-61.23 11.09-7.71 22.52-11.62 33.97-11.62 9.3 0 18.65 2.6 27.78 7.73 24.26 13.63 33.98 35.54 28.88 65.1l-.4 2.34h13.69l.39-1.5c7.13-27.84-6.22-59.85-31.75-76.09-11.39-7.25-24.67-11.07-38.42-11.07zm-6.97 68.84h2c1.4 0 2.77.02 4.13.04 1.34.02 2.67.03 3.98.03 2.03 0 3.7-.04 5.25-.13 4.58-.26 8.33-4.2 8.54-8.96.22-4.85-3.16-9.14-7.53-9.57-1.72-.17-3.57-.25-5.82-.25-1.43 0-2.87.03-4.31.06-1.42.03-2.84.06-4.26.06h-2v18.71zm86.68 128.53c-4.05-.04-7.88-1.69-10.77-4.66-2.93-3-4.52-6.94-4.46-11.08.12-8.41 7.09-15.25 15.55-15.25h.18c4.09.05 7.94 1.72 10.85 4.71 2.91 3 4.47 6.91 4.39 11.01-.16 8.56-7 15.26-15.59 15.26h-.15zm-.1-24.97c-5.07.17-9.16 4.45-9.13 9.53.03 5.2 4.28 9.42 9.48 9.42h.15c2.54-.04 4.92-1.1 6.7-2.96 1.77-1.85 2.7-4.26 2.62-6.77-.15-5.09-4.42-9.23-9.51-9.23h-.32z"
                      />
                    </svg>
                  </div>
                  <div className="wdi-heading">Crypto Wallet</div>
                </div>
              </Link>
              <Link to="/web-3/tokenization">
                <div
                  className={
                    accuratePath === "/web-3/tokenization"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="8"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg data-name="Layer 1" viewBox="0 0 257.35 296">
                      <path
                        fill="#9cb5d4"
                        stroke-width="0"
                        d="M127.47 296c-1.76-1.04-3.51-2.08-5.27-3.13-4.7-2.8-9.56-5.69-14.41-8.41-2.31-1.3-3.14-2.72-3.06-5.24.11-3.23.09-6.5.07-9.66-.01-2.42-.03-4.92.02-7.36.05-2.59-.89-4.29-3.02-5.52-7.38-4.23-14.76-8.48-22.13-12.73-10.45-6.02-21.26-12.25-31.91-18.33-.9-.51-1.94-.62-2.65-.62-1.08 0-2.11.24-2.91.67-4.97 2.68-9.98 5.56-15.31 8.79-1.05.64-1.99.95-2.85.95s-1.72-.29-2.71-.88c-5.52-3.33-11.58-6.84-18.55-10.73-2.01-1.12-2.78-2.41-2.76-4.58.09-6.92.09-14.02 0-21.72-.02-2.12.7-3.35 2.57-4.39 2.53-1.41 5.07-2.88 7.52-4.3 2.6-1.51 5.3-3.07 7.97-4.55 2.09-1.16 3.02-2.76 3.01-5.2-.05-20.04-.06-40.94 0-62.1 0-2.47-.91-4.08-2.98-5.22-2.46-1.36-4.93-2.8-7.33-4.19-2.58-1.5-5.25-3.06-7.92-4.52C.76 101.85-.03 100.5 0 98.2c.1-6.36.1-13.17 0-21.44-.03-2.21.74-3.5 2.71-4.6 5.98-3.33 12.13-6.88 18.8-10.87.91-.54 1.72-.81 2.5-.81s1.62.27 2.56.83c2.25 1.34 4.55 2.66 6.78 3.93 2.77 1.58 5.62 3.21 8.37 4.9 1.12.69 2.18 1.02 3.23 1.02 1.38 0 2.55-.59 3.31-1.04 8.6-5.04 17.39-10.1 25.89-15l8.04-4.64.87-.51c.71-.42 1.38-.82 2.06-1.15.6-.29 1.19-.44 1.76-.44 1.06 0 1.94.53 2.47 1.48.82 1.48.4 2.95-1.16 4.02-.8.55-1.67 1.04-2.59 1.55-.35.2-.7.39-1.05.6l-7.44 4.3c-8.52 4.93-17.33 10.02-26.02 14.98-2.21 1.26-3.17 2.94-3.11 5.47.05 2.34.03 4.73.02 7.05-.02 3.07-.05 6.25.09 9.4.13 3.05-.85 4.78-3.48 6.15-2.93 1.54-5.82 3.23-8.62 4.86-1.94 1.13-3.94 2.31-5.92 3.41-2.14 1.19-3.09 2.78-3.08 5.16.03 8.95.04 17.89.04 26.84 0 11.66.02 23.71.08 35.57 0 1.72 1.24 3.82 2.79 4.78a325.21 325.21 0 0015.28 8.87c2.13 1.16 2.94 2.58 2.88 5.07-.07 3.15-.06 6.33-.05 9.42 0 2.59.02 5.26-.02 7.88-.04 2.43.87 4.05 2.95 5.24 7.55 4.33 15.1 8.68 22.64 13.03 10.28 5.93 20.92 12.06 31.4 18.04.91.52 1.96.63 2.68.63 1.07 0 2.09-.23 2.88-.66 4.71-2.54 9.65-5.38 15.56-8.94.94-.56 1.78-.84 2.58-.84s1.6.26 2.5.79c6.14 3.62 12.54 7.32 19.04 10.99 1.74.98 2.4 2.16 2.38 4.2-.09 8-.09 15.2 0 22.02.03 2.12-.66 3.31-2.55 4.4-4.99 2.86-10.01 5.83-14.87 8.71-1.77 1.05-3.54 2.09-5.31 3.14h-2.42zm1.21-45.92c-2.85 0-5.77.93-9.2 2.94-6.53 3.82-8.97 8.09-9.01 15.75-.04 7.82 2.47 12.15 9.26 15.97 3.51 1.98 6.31 2.86 9.09 2.86s5.65-.94 8.87-2.95c5.36-3.36 11.43-7.16 8.59-15.81 2.41-8.57-3.05-12.64-8.38-15.78-3.49-2.05-6.33-2.97-9.22-2.97zm-113.54-26.1c2.64 2.34 5.35 3.48 8.29 3.48 3.42 0 6.76-1.59 9.58-3.15 6.94-3.84 9.46-8.25 9.32-16.25-.13-7.13-1.75-12.44-9.24-15.22-.95-.35-1.95-1.04-3-1.78-1.78-1.24-3.63-2.53-5.83-2.53h-.03c-2.32.01-4.3 1.32-6.22 2.58-1.04.69-2.03 1.33-2.98 1.72-2.98 1.22-11.94 4.88-8.68 15.42-2.31 7.15.64 12.44 8.79 15.73zM6.23 87.07c-.02.99-.11 2-.19 2.98-.24 2.73-.47 5.31.75 7.46 1.1 1.93 3.14 2.91 5.12 3.85 1.15.55 2.24 1.07 3.02 1.72 2.83 2.35 5.66 3.5 8.63 3.5 2.75 0 5.65-.95 9.41-3.09 6.98-3.96 9.52-8.36 9.36-16.23-.15-7.5-2.52-11.64-8.74-15.27-3.75-2.19-6.75-3.16-9.71-3.16s-5.92.99-9.27 3.13c-5.17 3.3-11.02 7.03-8.38 15.13zM168.46 248.7c-.49 0-.95-.14-1.44-.44-.91-.55-1.4-1.38-1.39-2.34 0-1.17.75-2.31 1.99-3.03 6.38-3.74 12.91-7.5 19.21-11.13l6.87-3.96c1.08-.62 2.16-1.25 3.23-1.88 3.08-1.79 6.26-3.64 9.42-5.37 2.09-1.14 3.05-2.81 3.01-5.26-.04-2.52-.03-5.1-.02-7.59.01-3.08.03-6.27-.06-9.42-.07-2.78.77-4.27 3.1-5.51 2.9-1.53 5.77-3.21 8.54-4.83 2.04-1.2 4.15-2.43 6.24-3.59 2.22-1.23 3.21-2.89 3.2-5.39-.07-19.87-.07-40.18 0-62.1 0-2.42-.93-4.02-3.04-5.19a482.05 482.05 0 01-7.8-4.46 459.49 459.49 0 00-7.7-4.4c-1.81-1.01-2.54-2.29-2.52-4.43.03-2.66.02-5.32.02-7.98 0-3.14-.02-6.4.04-9.58.05-2.54-.9-4.23-3.08-5.48-17.98-10.31-35.97-20.7-53.47-30.88-1.1-.64-2.13-.95-3.16-.95-1.1 0-2.17.35-3.39 1.09-2.89 1.76-5.9 3.48-8.8 5.15-2.12 1.22-4.25 2.43-6.35 3.68-.87.52-1.67.77-2.43.77s-1.55-.25-2.42-.76c-7.29-4.29-13.34-7.78-19.05-10.99-1.87-1.05-2.56-2.27-2.49-4.37.09-2.55.07-5.12.05-7.62 0-1.1-.02-2.2-.02-3.3v-3.34c.01-2.66.02-5.41-.03-8.12-.03-1.68.55-2.75 1.94-3.54l1.29-.74c6.25-3.6 12.51-7.19 18.74-10.82.67-.39 1.3-.58 1.91-.58.66 0 1.37.22 2.15.68 6.38 3.73 12.74 7.38 19.79 11.42 1.44.83 2.02 1.85 2.01 3.52-.02 2.59-.02 5.17 0 7.76 0 3.41.02 6.93-.04 10.39-.04 2.55.91 4.24 3.07 5.48 7.49 4.29 14.97 8.61 22.45 12.92 10.35 5.96 21.05 12.13 31.6 18.15.9.51 1.92.62 2.63.62 1.08 0 2.12-.24 2.92-.67 4.84-2.62 9.93-5.54 15.56-8.94.93-.56 1.77-.84 2.56-.84s1.59.26 2.5.8c5.5 3.27 11.38 6.66 19.04 11 1.77 1 2.48 2.21 2.46 4.17-.07 8.17-.07 15.37 0 22.01.02 2.08-.73 3.35-2.59 4.39-2.48 1.39-4.95 2.82-7.41 4.24-2.64 1.53-5.38 3.12-8.08 4.62-2.08 1.15-3 2.76-3 5.21.06 21.32.06 42.21 0 62.11 0 2.4.93 4 3.04 5.18 2.64 1.47 5.31 3.01 7.89 4.51 2.53 1.46 5.06 2.93 7.61 4.35 1.83 1.02 2.57 2.3 2.54 4.41-.08 7.17-.08 14.48 0 21.73.02 2.16-.68 3.41-2.51 4.44-6.48 3.66-12.89 7.36-19.04 11-.89.52-1.69.78-2.46.78s-1.65-.28-2.61-.86c-2.46-1.49-4.99-2.94-7.44-4.34-2.47-1.41-5.02-2.87-7.47-4.36-1.22-.74-2.31-1.08-3.42-1.08s-2.17.33-3.37 1.04c-7.88 4.62-15.92 9.26-23.71 13.75-4.68 2.7-9.35 5.39-14.02 8.1-1.22.71-2.09 1.02-2.84 1.02zm65.45-59.33c-3.51 0-6.86 1.62-9.68 3.2-6.74 3.79-9.23 8.12-9.21 15.99.02 7.22 1.63 12.61 9.39 15.45.95.35 1.95 1.03 3 1.76 1.78 1.23 3.62 2.49 5.81 2.49 2.41-.04 4.38-1.36 6.29-2.63 1.04-.7 2.03-1.36 3-1.76 7.92-3.28 10.83-8.25 8.67-14.78.02-1.04.11-2.09.2-3.11.24-2.74.46-5.33-.75-7.48-1.09-1.93-3.12-2.91-5.08-3.86-1.15-.56-2.24-1.08-3.02-1.74-2.8-2.37-5.62-3.53-8.62-3.53zM215.55 87.34c-.02.95-.1 1.92-.19 2.86-.23 2.65-.46 5.16.73 7.26 1.07 1.89 3.04 2.84 4.95 3.76 1.11.54 2.17 1.05 2.91 1.68 2.91 2.46 5.82 3.66 8.89 3.66 2.84 0 5.83-1 9.68-3.24 6.36-3.7 10.3-7.84 8.85-16.04-.17-.96-.07-2.13.03-3.37.18-2.12.36-4.31-.74-6.18-1.13-1.92-3.15-2.93-5.1-3.9-1.12-.56-2.17-1.09-2.96-1.73-2.96-2.43-5.87-3.61-8.92-3.61-2.88 0-5.88 1.04-9.45 3.28-5.4 3.39-11.52 7.24-8.69 15.57zM128.74 8.35c-2.75 0-5.59.89-8.95 2.8-6.87 3.91-9.4 8.31-9.33 16.23.06 7.47 2.49 11.67 8.96 15.47 3.56 2.09 6.44 3.02 9.33 3.02s5.76-.95 9.11-2.99c4.7-2.87 11.1-6.77 8.42-15.69 2.84-8.95-3.71-12.95-8.54-15.89-3.31-2.02-6.17-2.96-9-2.96zm0 217.74c-39.24 0-72.64-29.37-77.67-68.32-2.73-21.14 3.18-41.99 16.64-58.71 13.54-16.81 32.78-27.08 54.19-28.94 1.58-.14 3.17-.24 4.76-.35l2.14-.15c34.62.11 65.44 23.38 74.97 56.6l.13.46c.19.64.37 1.24.44 1.8.19 1.48-.67 2.78-2.14 3.24-.27.08-.55.13-.83.13-1.12 0-2.13-.66-2.64-1.73-.24-.51-.42-1.12-.6-1.76l-.12-.42c-8.96-30.75-37.22-52.23-68.74-52.23-1.28 0-2.58.04-3.86.11-34.48 1.94-62.45 26.94-68.02 60.78-3.22 19.6 2.03 39.94 14.42 55.81 12.34 15.81 30.7 25.8 50.38 27.42 2.09.17 4.21.26 6.29.26 35.57 0 65.62-25.62 71.46-60.92.11-.65.23-1.3.36-1.95.36-1.81 1.44-2.89 2.87-2.89.19 0 .4.02.6.06 1.8.33 2.7 1.79 2.42 3.9-4.75 36.04-34.46 64.44-70.65 67.53-2.27.19-4.56.29-6.82.29zm-.06-26.95c-.86 0-1.78-.29-2.8-.89-12.38-7.25-25.24-14.68-39.3-22.71-2.09-1.19-2.86-2.5-2.84-4.84.09-14.87.1-30.16 0-45.44-.01-2.36.75-3.68 2.82-4.86 13.94-7.94 26.79-15.37 39.31-22.7 1.04-.61 1.97-.91 2.83-.91s1.75.28 2.78.89c13.9 8.12 27.79 16.11 39.55 22.85 1.88 1.08 2.6 2.31 2.58 4.4-.07 5.54-.06 11.16-.05 16.59 0 2.19.01 4.39.01 6.58s0 4.34-.01 6.51c-.01 5.36-.03 10.91.05 16.37.03 2.11-.68 3.35-2.55 4.42-11.66 6.69-25.47 14.63-39.55 22.85-1.04.6-1.96.9-2.82.9zm28.2-63.97c-7.55 4.37-14.68 8.5-21.95 12.61-2.32 1.31-3.3 3-3.28 5.66.06 6.97.06 14.06.05 20.91v10.4c0 .66.08 1.29.17 1.95.04.31.09.66.13 1.04l.33 3.05 7.92-4.57c8.68-5.01 16.88-9.75 25.19-14.61 1.18-.69 2.08-2.2 2.09-3.52.05-9.64.05-19.15.05-29.22v-9.88s-8.16 4.72-10.7 6.18zm-67.12 4.6c0 9.59-.01 18.66.08 27.83.02 1.72 1.37 3.54 2.66 4.3 8.41 4.96 17.02 9.92 25.34 14.71l2.76 1.59c.52.3 1.03.47 1.56.66.23.08.48.16.77.27l2.71 1.03v-9.75c0-9.73.01-18.93-.08-28.31-.02-1.87-1.79-3.44-2.73-4.01-2.97-1.8-6.03-3.55-8.99-5.24-1.15-.66-2.3-1.31-3.44-1.97l-20.64-11.92v10.81zm39.1-35.89c-.92 0-1.9.24-2.62.65-8 4.54-15.84 9.06-24.13 13.85l-8.81 5.08 2.42 1.82c.16.12.29.22.4.31.3.24.52.39.74.53l5.41 3.13c7.85 4.55 15.97 9.25 24.02 13.78.59.33 1.32.5 2.15.5 1.08 0 2.26-.29 3.13-.78 4.97-2.76 9.97-5.66 14.8-8.46l18.19-10.52-8.63-4.99c-8.63-4.99-16.77-9.7-25.1-14.42-.55-.31-1.22-.47-1.98-.47z"
                      />
                    </svg>
                  </div>
                  <div className="wdi-heading">Tokenization</div>
                </div>
              </Link>
              <Link to="/web-3/marketplace-development">
                <div
                  className={
                    accuratePath === "/web-3/marketplace-development"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="8"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg data-name="Layer 1" viewBox="0 0 258.81 296">
                      <path
                        fill="#9cb5d4"
                        stroke-width="0"
                        d="M43.83 296c-1.33-1.12-1.77-2.64-1.55-5.21 1.36-15.74 14.26-27.9 30.02-28.29 1.34-.03 2.69-.04 4.05-.04 1.16 0 2.33 0 3.52.02 1.22 0 2.46.02 3.72.02h1.51l7.86-27.48H27.65C11.12 234.98.01 223.88 0 207.35V69.54c0-16.5 11.12-27.59 27.66-27.62.72 0 1.43 0 2.15-.01.77 0 1.54-.01 2.31-.01 1.03 0 2.06 0 3.09.04 1.86.06 3 1.1 2.99 2.69-.02 1.61-1.16 2.6-3.06 2.65-.86.02-1.73.03-2.59.03-.67 0-3.37-.02-4.04-.02-1.02 0-2.03 0-3.05.04-11 .34-19.97 9.32-20 20.03-.09 30.23-.07 60.96-.06 90.67 0 10.34.01 20.68.01 31.02 0 .33.06.59.12.87.03.13.06.29.1.52l.31 1.63h43.69c12.3 0 28.52 0 44.83-.06 2.85 0 4.35.79 5.4 2.83.08.16.17.3.27.44.66.95 1.24 1.99 1.87 3.1 1.55 2.75 3.15 5.6 5.83 7.06 1.39.76 3.07 1.12 5.28 1.12 1.25 0 2.53-.11 3.77-.22 1.2-.1 2.34-.2 3.41-.2h14.93c4.12 0 8.24 0 12.36.05h.14c1.88 0 4.24-.36 5.88-3.2.83-1.43 1.76-2.78 2.75-4.22.9-1.31 1.84-2.67 2.68-4.09 1.15-1.93 2.51-2.65 5-2.65 16.64.05 33.26.06 45.89.06h43.49v-37.9V69.7c0-13.8-8.62-22.38-22.5-22.39h-4.35c-.97 0-1.94 0-2.91-.04-1.9-.06-3.04-1.06-3.05-2.66 0-.75.24-1.4.71-1.87.52-.52 1.28-.8 2.21-.8 0 0 4.26-.02 4.98-.02 2.74 0 5.66.06 8.48.49 12.59 1.93 21.75 12.47 21.78 25.08.13 51.57.13 98 0 141.92-.04 14.24-11.53 25.46-26.14 25.55-7.19.04-14.93.06-24.38.06-5.94 0-11.89 0-17.83-.01-5.95 0-11.89-.01-17.84-.01h-6.68l7.81 27.46h11.42c16.48.1 29.07 11.17 31.33 27.55.43 3.12.05 4.77-1.43 5.99H43.83zm42.82-28.18c-5.44 0-9.89.02-14.02.06-11.97.13-22.4 8.83-24.26 20.24l-.38 2.32h162.87l-.35-2.3c-.03-.17-.05-.33-.06-.47a7.56 7.56 0 00-.19-1.07c-3.08-11.19-13.14-18.72-25.02-18.74-11.29-.02-22.59-.02-33.88-.02h-54.8c-3.3 0-6.61-.01-9.91-.01zm4.14-5.52h77.2l-7.78-27.2H98.55l-7.77 27.2zm119.75-32.68c2.22 0 4.44 0 6.66.01 2.22 0 4.44.01 6.67.01h.01c2.99 0 5.99-.01 8.98-.05 10.05-.13 18.28-7 19.99-16.68.53-3.01.58-5.98.62-9.13.02-1.38.04-2.8.11-4.22l.1-2.09h-24.02c-19.22 0-41.55 0-63.46.07-1.63 0-3.25 1.24-4.07 2.38-2.3 3.21-4.48 6.56-6.59 9.8-.85 1.31-1.85 1.85-3.45 1.85H132.58c-9.62 0-17.71-.02-25.94-.12-.95-.01-2.5-.88-3.3-1.85-2.14-2.57-3.97-5.44-6.04-8.95-1.67-2.82-3.95-3.2-5.96-3.2-20.2.04-40.36.04-60.53.04H10.36c-.67 0-1.33.04-2.05.08l-1.01.06-1.91.09v8.88c0 14.65 8.4 23.04 23.03 23.04h182.12zm-81.12-55.88c-.91 0-1.87-.31-3.03-.97-21.58-12.26-44.37-25.08-71.72-40.35-2.3-1.29-3.11-2.66-3.11-5.24.09-24.99.1-51.46.01-80.92 0-2.38.73-3.63 2.83-4.8C82.25 25.89 105.12 13.02 126.38.95c1.14-.65 2.1-.95 3.02-.95s1.94.32 3.14 1c22.54 12.77 46.01 25.96 71.73 40.33 2.2 1.23 2.97 2.55 2.95 5.04-.09 9.8-.07 19.76-.06 29.39v21.67c-.01 9.79-.03 19.92.06 29.88.02 2.49-.75 3.81-2.95 5.04-23.65 13.22-47.87 26.84-71.98 40.48-1.08.61-1.99.9-2.87.9zm.04-167.43c-1.45 0-2.69.6-3.49 1.06-21.59 12.22-43.74 24.68-65.83 37.03-2.23 1.25-3.18 2.85-3.17 5.37.06 24.6.06 49.55 0 74.15 0 2.52.94 4.12 3.17 5.37 22.78 12.75 45.01 25.26 66.08 37.19 1.11.63 2.15.93 3.18.93s2.11-.32 3.31-.99c23.26-13.16 44.8-25.27 65.83-37.03 2.33-1.3 3.31-2.99 3.29-5.63-.07-9.17-.06-18.49-.05-27.51v-9.12-9.16c0-9.2-.02-18.7.05-28.05.02-2.65-.96-4.33-3.29-5.63-22.76-12.72-44.9-25.19-65.82-37.04-1.13-.64-2.2-.95-3.26-.95zm70.08 158.12c-.86 0-1.53-.35-1.98-1.05-.4-.61-1.47-2.22 1.72-4.36l3.78-2.53c6.17-4.14 12.55-8.42 18.88-12.52 2.38-1.54 3.38-3.38 3.36-6.13-.07-7.49-.07-15.11-.06-22.48v-13.55c0-2.46.91-3.18 2.29-3.51.2-.05.4-.07.59-.07 1.43 0 2.49 1.38 2.5 3.29.04 4.83.03 9.74.02 14.49v6c0 2 0 3.83-.01 5.75-.01 4.66-.03 9.47.04 14.21.03 1.9-.6 3.06-2.23 4.14-4.94 3.25-9.87 6.54-14.79 9.82-3.77 2.51-7.54 5.03-11.31 7.53-.97.64-1.93.98-2.79.98zm-140.61-.1c-.72 0-1.43-.21-2.03-.61-4.11-2.68-8.26-5.46-12.27-8.15-1.67-1.12-3.34-2.24-5.01-3.35-.95-.63-1.91-1.25-2.88-1.87-2.36-1.51-4.58-2.93-6.63-4.61-.95-.77-1.82-2.34-1.84-3.29-.18-12.23-.15-24.68-.11-36.71v-4.25c.01-.98.28-3.25 2.68-3.25 2.39 0 2.67 2.29 2.68 3.27.04 4.38.03 8.76.02 13.14v10.51c.01 4.33.03 8.81-.05 13.2-.04 2.31.83 3.93 2.82 5.23 5.45 3.57 10.96 7.25 16.29 10.82l5.62 3.76.53.35c.37.25.75.49 1.11.75.84.61 2.66 2.21 1.41 4-.46.65-1.36 1.06-2.35 1.06zm70.45-18.47c-.47 0-.94-.02-1.41-.06-7.9-.66-14.32-6.91-15.26-14.87-.91-7.62 3.77-15.04 11.12-17.63 1.86-.66 3.77-.99 5.68-.99 5.86 0 11.26 3.17 14.45 8.48.22.37.43.73.68 1.17l1.46 2.51 1.72-.98c1.74-.99 3.46-2.04 5.13-3.06 3.81-2.32 7.41-4.52 11.29-6.15 7.76-3.28 10.77-8.5 9.47-16.43-.39-2.38-.28-4.88-.16-7.53.04-.98.09-1.96.11-2.94.04-2 1.03-3.19 2.65-3.19 1.7.04 2.68 1.19 2.69 3.08.03 4.22.03 8.44.03 12.67v9.9c0 1.53-.65 2.44-2.53 3.5-8.75 4.96-18.07 10.26-27.45 15.77-1.54.9-2.92 2.63-3.43 4.29-2.28 7.46-8.81 12.47-16.23 12.47zm-.06-28.16c-6.22.03-11.29 5.13-11.3 11.35 0 3.02 1.18 5.87 3.34 8.04 2.17 2.17 5.02 3.36 8.04 3.36h.24c6.22-.13 11.21-5.31 11.13-11.54-.08-6.19-5.19-11.22-11.38-11.22h-.06zm-46.87-9.42c-1.45-.01-2.66-1.24-2.65-2.69 0-1.44 1.23-2.65 2.66-2.65.72 0 1.38.29 1.89.81.51.51.79 1.18.78 1.88 0 1.44-1.23 2.66-2.67 2.66h-.02zm-.02-18.77c-1.75 0-2.64-1.36-2.65-4.04 0-2.23 0-4.46.01-6.7.02-4.54.04-9.24-.07-13.86-.05-2.27.73-3.56 2.87-4.75 9.71-5.4 18.45-10.4 26.73-15.29 1.74-1.03 3.32-3 3.93-4.91 2.33-7.26 8.82-12.13 16.16-12.13.48 0 .98.02 1.46.06 7.84.69 14.08 6.73 15.17 14.68 1.03 7.48-3.66 15.11-10.92 17.76-1.9.69-3.86 1.04-5.83 1.04-5.76 0-11.08-3.02-14.22-8.08l-2.49-4.03-6.59 3.77c-6.18 3.53-12.57 7.18-18.77 10.85-1.56.92-2.01 3.18-2.03 4.36-.06 3.83-.06 7.73-.05 11.49v5.83c-.01 3.89-1.99 3.94-2.64 3.95h-.09zm46.81-56.28c-6.22.08-11.25 5.2-11.23 11.43.03 6.23 5.12 11.3 11.34 11.32 3.08 0 5.96-1.22 8.13-3.43 2.17-2.22 3.34-5.12 3.28-8.18-.12-6.14-5.23-11.14-11.38-11.14h-.14zm47 37.51c-1.45-.05-2.63-1.31-2.59-2.75a2.685 2.685 0 012.66-2.59c.78.02 1.44.33 1.94.85.5.53.76 1.2.74 1.89-.04 1.41-1.27 2.6-2.67 2.6h-.08z"
                      />
                    </svg>
                  </div>
                  <div className="wdi-heading">Marketplace Development</div>
                </div>
              </Link>
              <Link to="/web-3/trading-bot">
                <div
                  className={
                    accuratePath === "/web-3/trading-bot"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="8"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg data-name="Layer 1" viewBox="0 0 278.31 297.02">
                      <path
                        fill="#9cb5d4"
                        stroke-width="0"
                        d="M164.84 40.11h.01c-1.65-10.83-7.95-18.04-18.73-21.42-.92-.29-1.87-.48-2.78-.67-.4-.08-.8-.17-1.2-.25l-.11-.02h-5.47l-.25.02-.19.08c-.13.06-.26.11-.38.13-6.8.86-12.87 4.37-17.09 9.89-4.27 5.58-6.09 12.47-5.13 19.39 1.78 12.77 12.82 22.4 25.67 22.4 1 0 2.01-.06 3.01-.18 7.07-.83 13.35-4.41 17.67-10.08 4.25-5.57 6.02-12.42 4.97-19.29zm-25.6-17.29c5.55 0 10.78 2.19 14.71 6.15 3.94 3.96 6.1 9.21 6.09 14.78-.02 11.43-9.38 20.72-20.86 20.72-5.58.01-10.81-2.17-14.73-6.11s-6.08-9.19-6.07-14.78c.01-11.45 9.36-20.76 20.83-20.76v-1l.03 1zm6.7 25.57c-.01 2.78-1.33 4.97-3.83 6.32-.64.34-.92.64-.85 1.4.05.54.03 1.1 0 1.64-.07 1.46-1.1 2.48-2.51 2.48h-.02c-.77 0-1.48-.3-1.95-.82-.41-.45-.6-1.02-.54-1.64.16-1.68-.12-2.96-2.06-3.74-.88-.35-1.59-1.22-2.21-1.99l-.08-.1c-.86-1.06-.73-2.47.33-3.41.48-.43 1.03-.66 1.66-.66s1.24.25 1.78.71c.16.14.32.29.48.43.48.44.89.82 1.37 1.11.43.26.88.4 1.29.4.49 0 .91-.2 1.23-.58.45-.53.75-1.44.69-2.12-.08-.94-.81-1.53-1.96-1.58-1.87-.09-3.38-.64-4.63-1.69-1.9-1.6-2.84-3.9-2.58-6.33.26-2.44 1.68-4.5 3.88-5.66.19-.1.38-.19.59-.29l.19-.09v-.7c-.01-.61-.02-1.24 0-1.85.04-1.47 1.1-2.54 2.52-2.54 1.43.03 2.47 1.06 2.53 2.51v2.38c.35.23.68.45 1.01.67.8.52 1.52 1 2.19 1.56.61.51.95 1.14 1 1.83.05.66-.19 1.32-.68 1.86-.47.52-1.11.81-1.81.81-.62 0-1.25-.22-1.82-.64-.53-.39-1.11-.78-1.73-1.05-.25-.11-.5-.16-.75-.16-.53 0-1.02.24-1.46.72-.61.65-.75 1.37-.43 2.15.33.77.91 1.2 1.89 1.39l.61.11c.99.18 2.01.36 2.89.81h-.01c2.48 1.28 3.78 3.48 3.78 6.35zM68.52 297c-1.49-.53-3-1.01-4.47-1.47-3.32-1.05-6.75-2.13-9.72-3.78-10.16-5.64-16.45-14.65-18.68-26.78-.23-1.24-1.23-3.21-2.73-3.68-7.89-2.51-12.81-7.72-15.03-15.92l-.3-1.11H3.86c-2.92-.03-3.81-.94-3.82-3.89-.02-9.85-.02-20.68 0-33.1 0-1.47.38-3.93 2.88-3.93s2.89 2.46 2.89 3.93c.02 6.99.01 13.97 0 21.04v9.95H17.6V137.29c.01-.64.03-1.29-.08-1.98-.5-3.25-2.66-5.2-5.77-5.23-3.18 0-5.32 1.87-5.86 5.14-.13.78-.11 1.54-.09 2.21 0 .29.01.48.01.67v11.38c0 12.38 0 25.19-.06 37.83 0 1.31-.39 2.66-.96 3.36-.46.57-1.12.89-1.85.89-1.25 0-2.39-.86-2.77-2.09-.13-.43-.15-.99-.15-1.58v-12.15c-.02-13.11-.04-26.66.03-39.99.03-5.56 3.97-10.22 9.59-11.34.68-.14 1.39-.2 2.09-.2 4.63 0 8.86 2.81 10.54 6.99.86 2.14 1.05 4.44 1.06 5.99.07 12.4.06 24.93.06 37.05v16.27l11.79-5.19v-13.74c.08-23.26 15.39-41.94 38.1-46.47 2.77-.55 5.82-.82 9.31-.83 22.42-.03 44.84-.05 67.25-.05 15.28 0 30.55 0 45.83.02 26.5.03 47.34 20.8 47.46 47.29V185.32l11.79 5.18v-5.28-14.51c0-10.74-.03-22.92.04-34.69.04-6.6 5.13-11.78 11.6-11.78 1.22 0 2.45.19 3.65.58 4.71 1.5 8.02 5.88 8.05 10.65.09 17.2.06 34.67.03 51.56v1.15c0 2.03-1.13 3.35-2.88 3.35s-2.88-1.36-2.88-3.63c-.02-11.79-.02-23.57-.01-35.36v-14.85c.01-.67.02-1.36-.04-2.07-.31-3.23-2.78-5.57-5.86-5.57-3.15.03-5.56 2.35-5.87 5.66-.04.41-.04.83-.03 1.25v101.33h11.79v-31c0-1.47.38-3.93 2.88-3.93s2.89 2.46 2.89 3.93c.02 12.57.02 23.08 0 33.09 0 2.96-.9 3.87-3.83 3.89-1.64.02-3.28.02-4.92.02h-8.81l-.3 1.1c-2.23 8.23-7.15 13.43-15.03 15.89-1.34.42-2.42 1.94-2.65 3.11-3.58 18.13-14.13 28.67-32.25 32.22-.37.07-.67.24-.92.41H68.52V297zm22.67-167.01c-3.87 0-7.09.02-10.13.06-21.95.32-39.9 18.32-40.03 40.13-.15 26.18-.15 54.39 0 88.77.07 18.02 14.23 32.17 32.23 32.21 22.03.05 44.21.08 65.92.08s43.89-.03 65.92-.08c18-.04 32.15-14.2 32.23-32.22.12-28.92.12-58.69 0-88.47-.08-19.21-13.73-36-31.76-39.06-6.59-1.12-13.34-1.27-19.65-1.27-1.54 0-3.08 0-4.62.02-1.53 0-3.07.02-4.6.02-2.37 0-4.29-.02-6.06-.07-.7 0-1.12.36-1.37.58-.08.07-.14.12-.22.18l-.61.45v38.39c0 3.89-1.51 4.22-3.19 4.22-8.57.03-17.14.04-25.71.04s-17.62 0-26.43-.04c-2.08 0-3.02-.94-3.15-3.14-.09-1.58-.07-3.22-.06-4.79 0-.62.01-1.24.01-1.86v-34.11h-1.5c-2.96 0-5.88 0-8.77-.02h-.81c-2.56 0-5.1-.02-7.63-.02zm152.02 125.39l1.92-.56c5.6-1.64 9.58-6.69 9.67-12.29.21-12.69.21-25.29 0-37.46-.1-5.86-4.74-11.53-9.92-12.14l-1.67-.2v62.64zM33.18 192.84c-5.53 1.37-9.6 6.59-9.68 12.43-.18 12.73-.17 25.24.01 37.16.09 5.81 4.47 11.32 9.76 12.27l1.77.32v-62.63l-1.86.46zm82.7-24.9h46.67v-37.69h-46.67v37.69zm23.3 111.49H74.75c-13.34 0-21.97-8.61-21.98-21.93 0-16.69-.02-33.38 0-50.07.02-12.94 8.72-21.65 21.66-21.66h129.15c13.34 0 21.97 8.62 21.98 21.93v49.78c0 13.34-8.63 21.96-21.96 21.96h-64.43zm-38.09-87.89H74.42c-9.77 0-15.85 6.11-15.86 15.94v50.08c0 10.06 6 16.07 16.02 16.07h129.18c10.02 0 16-6.02 16.01-16.09v-49.79c0-10.3-5.9-16.21-16.18-16.21h-102.5zm38.12 57.12c-6.88-.22-12.04-3.34-15.31-9.26-.68-1.23-.9-2.33-.65-3.2.19-.64.66-1.17 1.4-1.57.47-.25.92-.38 1.34-.38 1.29 0 2.31 1.25 2.94 2.3 2.43 4.05 6.15 6.37 10.21 6.37s7.82-2.34 10.26-6.41c.62-1.03 1.63-2.26 2.9-2.26.43 0 .9.14 1.39.41 2.22 1.21 1.48 3.38.84 4.56-3.28 6.06-8.29 9.16-15.33 9.46v-.02zm39.5-8.83c-3.14 0-6.09-1.21-8.29-3.42-2.19-2.2-3.39-5.12-3.38-8.25.02-6.39 5.25-11.59 11.67-11.59h.11c6.44.06 11.53 5.12 11.57 11.53.02 3.13-1.17 6.07-3.36 8.28-2.2 2.22-5.14 3.44-8.29 3.45h-.03zm0-17.44c-1.59 0-3.08.62-4.19 1.74a5.69 5.69 0 00-1.67 4.13c.03 3.16 2.55 5.69 5.73 5.76h.13c1.59 0 3.08-.62 4.2-1.75 1.09-1.1 1.7-2.58 1.68-4.13-.03-3.15-2.55-5.68-5.74-5.75h-.14zM99.6 239.83c-3.13 0-6.06-1.21-8.26-3.4s-3.41-5.12-3.41-8.24c0-6.41 5.24-11.62 11.67-11.62 6.49.04 11.62 5.09 11.68 11.5.03 3.13-1.15 6.07-3.34 8.28a11.613 11.613 0 01-8.28 3.47h-.06zm0-17.45c-1.6 0-3.09.62-4.2 1.75a5.744 5.744 0 00-1.66 4.15c.05 3.16 2.58 5.67 5.76 5.73 1.69 0 3.18-.61 4.31-1.76 1.09-1.1 1.69-2.6 1.67-4.15-.05-3.15-2.58-5.67-5.76-5.73h-.12zm39.55-110c-5.18-.01-8.88-2.6-10.99-7.69-.58-1.39-1.16-2.78-1.74-4.16l-.12-.29c-1.51-3.6-3.05-7.28-4.48-10.92-.6-1.53-1.66-3.29-4.56-3.29H117c-2.1.07-4.29.11-6.69.11-2.09 0-4.32-.03-7-.08-11.15-.22-19.96-8.99-20.07-19.97-.14-14.82-.15-30.28 0-45.94C83.32 8.99 92.21.17 103.45.06 107.6.02 112.07 0 117.52 0H173.72c12.76.03 21.37 8.59 21.41 21.29.05 15.92.05 30.19 0 43.62-.05 12.38-8.8 21.07-21.28 21.14-1.03 0-2.05.02-3.08.04h-.2c-1.22.02-2.45.04-3.67.04-1.92 0-3.5-.04-4.96-.13-.2-.01-.39-.02-.57-.02-3.2 0-4.38 1.97-5.11 3.9-1.34 3.55-2.85 7.1-4.31 10.54l-.14.33c-.56 1.31-1.12 2.63-1.66 3.95-2.12 5.09-5.81 7.67-10.96 7.67h-.04zm-17.72-32.12c2.1 0 3.23.77 4.03 2.76 1.4 3.5 2.87 7.04 4.3 10.47l.18.44c1.07 2.58 2.14 5.16 3.2 7.75.93 2.3 2.46 4.94 6.01 4.94h.18c3.89-.1 5.27-3.47 5.85-4.91 1.04-2.56 2.1-5.1 3.16-7.65 1.5-3.6 3.05-7.33 4.52-11.02.8-2 1.92-2.78 4.01-2.78h.16c2.25.04 4.64.06 7.51.06 2.16 0 4.32-.01 6.48-.02h2.74c9.45-.05 15.57-6.17 15.59-15.59.03-14.61.03-29.19 0-43.35-.02-9.43-6.15-15.53-15.61-15.55-4.61 0-9.22-.01-13.82-.01H118.5c-4.73 0-9.45 0-14.17.02-9.14.03-15.3 6.15-15.33 15.23-.04 14.12-.04 28.9 0 43.93.02 9.09 6.16 15.24 15.27 15.3h.64c2.83.02 5.65.04 8.48.04s5.52-.02 7.91-.07h.16-.03z"
                      />
                    </svg>
                  </div>
                  <div className="wdi-heading">Trading Bot</div>
                </div>
              </Link>
            </Slider>

            {/* {accuratePath === "/blockchain" ||
            accuratePath === "/blockchain/Web3" ||
            accuratePath === "/blockchain/Web3/smart-contract" ||
            accuratePath === "/blockchain/Web3/crypto-wallet" ||
            accuratePath === "/blockchain/Web3/tokenization" ||
            accuratePath === "/blockchain/Web3/marketplace-development" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="web-design"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/blockchain/Web3">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Web 3
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/blockchain/Web3/smart-contract">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Smart Contract
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/blockchain/Web3/crypto-wallet">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Crypto Wallet
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/blockchain/Web3/tokenization">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Tokenization
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/blockchain/Web3/marketplace-development">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Marketplace Development
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Web 3</div>
                            <div className="text-para">
                              Web 3 is the concept of the next generation of web
                              which is decentralized, permissionless, has native
                              payments and is trustless i.e. it does not require
                              trust of third party organizations but rather the
                              trust is based upon the people's participation in
                              making transactions possible. All the underlying
                              technologies that bind Web 3 are built using
                              Blockchain.
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Smart Contract</div>
                            <div className="text-para">
                              Smart contracts are simply programs stored on a
                              blockchain that run when predetermined conditions
                              are met. They typically are used to automate the
                              execution of an agreement so that all participants
                              can be immediately certain of the outcome, without
                              any intermediary’s involvement or time loss.
                              Benefits of smart contracts include:{" "}
                            </div>
                            <ul>
                              <li>Speed and accuracy</li>
                              <li>Trust and transparency</li>
                              <li>Security</li>
                              <li>Savings</li>
                            </ul>
                            Smart contracts assist in functioning of
                            transactions by applying computer logic to every
                            transaction; they help decrease the time taken for
                            each transaction to fulfill and also make sure that
                            the transactions are error free. Also, the payment
                            made through these transactions are immediately
                            realized, hence leading to higher efficiency. Our
                            smart contract services include:
                            <ul>
                              <li>Smart contract architecture</li>
                              <li>Smart contract design and development</li>
                              <li>Smart contract audit</li>
                              <li>Smart contract optimization</li>
                            </ul>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Crypto Wallet</div>
                            <div className="text-para">
                              Just like storing physical currency, wallets are
                              used. Cryptocurrencies are stored in crypto
                              wallets. However, a crypto wallet can not only
                              store crypto currencies but can also store DeFi,
                              NFTs, DAOs etc,. A crypto wallet contains
                              passwords which give access to digital assets;
                              these can be in the form of highly encrypted USB
                              sticks or in the form of mobile apps which give
                              access to wallets. These wallets contain private
                              keys which give access to the wallet and provide
                              the ability to do transactions. Crypto wallets are
                              further classified into custodial and non
                              custodial wallets. Where custodial ones give
                              access to third parties for maintenance of private
                              keys and funds thus are more likely to get
                              attacked by hackers and non-custodial ones provide
                              full access to the user; since these aren’t stored
                              anywhere hence are less prone to attacks from
                              hackers. Our crypto wallet development services
                              include:
                            </div>
                            <ul>
                              <li>Web 3 wallet development</li>
                              <li>DeFi wallet development</li>
                              <li>Tron wallet development</li>
                              <li>White label wallet development</li>
                              <li>Multi currency wallet development</li>
                              <li>NFT wallet development</li>
                              <li>Ethereum wallet development</li>
                              <li>Web wallet development</li>
                              <li>Mobile wallet development</li>
                              <li>Desktop wallet development</li>
                              <li>Centralized wallet development</li>
                              <li>Bitcoin wallet development</li>
                              <li>Ethereum wallet development</li>
                              <li>Web wallet development</li>
                              <li>Mobile wallet development</li>
                              <li>Desktop wallet development</li>
                              <li>Centralized wallet development</li>
                            </ul>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Tokenization</div>
                            <div className="text-para">
                              The process of tokenizing anything involves
                              turning it into a digital token that can be used
                              in a blockchain application. It transforms the
                              ownerships and rights of particular assets into a
                              digital form. By tokenization, you can transform
                              indivisible assets into token forms. Thus a single
                              asset can be bought by multiple holders through
                              the process of tokenization thus leading to parity
                              distribution of asset. There can be many different
                              types of tokens: security tokens, platform tokens,
                              utility tokens, fungible tokens, non- fungible
                              tokens etc. where each set of tokens serve a
                              particular purpose. Our asset tokenization
                              services include:
                            </div>
                            <ul>
                              <li>Real estate</li>
                              <li>Commodities</li>
                              <li>Documents</li>
                              <li>Utility assets</li>
                              <li>Security tokens</li>
                              <li>Fungible and non-fungible tokens</li>
                            </ul>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Marketplace Development
                            </div>
                            <div className="text-para">
                              Any digital asset whether it is cryptocurrency or
                              token requires a marketplace where they can be
                              traded between people, thus many Web 3 based
                              startups are flocking to create a marketplace
                              where these digital assets can be traded. NFT
                              Marketplace is the most common marketplace where
                              different designers showcase their artwork which
                              are bought by people and this gives the exclusive
                              ownership over the artwork. For any marketplace to
                              work it requires certain infrastructure which
                              includes storefront, search items, filters,
                              listings, status of listing, buying and auction,
                              wallet, ratings etc. all these are imperative for
                              any marketplace to work. Our Marketplace
                              development services include:
                            </div>
                            <ul>
                              <li>NFT Marketplace Design and Development</li>
                              <li>NFT Smart Contract Development and Audit</li>
                              <li>NFT Marketplace Support and Maintenance</li>
                            </ul>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )} */}

            {accuratePath === "/web-3/blockchain-development" ||
              accuratePath === "/cryptocurrency-development" ||
              accuratePath === "/web-3" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="web-design"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/blockchain/blockchain-development">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Blockchain Development
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >

                        {/* <MetaTags>
                          <meta
                            id="meta-description"
                            name="description"
                            content="Realize the power of blockchain with Kindlebit. Our tailored blockchain services are here to revolutionize your business.  So, Contact us right now! "
                          />
                        </MetaTags> */}
                        
                        {path === '/web-3' && (
                          <Helmet>
                            <title>Blockchain Application Development & Software Development</title>
                            <meta
                              name="keyword"
                              content="blockchain app development, blockchain application development, blockchain software development companies, blockchain app development services"
                            />
                            <meta
                              name="description"
                              content="We offer blockchain application development services that provide you with a range of decentralized solutions and add security and transparency to your business."
                            />
                          </Helmet>
                        )}
                        {path === '/web-3/blockchain-development' && (
                         <Helmet>
                         <title>Blockchain Developer & Development Services | Crypto Wallet</title>
                         <meta
                           name="keyword"
                           content=" blockchain development companies, blockchain development services, crypto wallet development, blockchain software development company, certified blockchain developer"
                         />
                         <meta
                           name="description"
                           content="Leading blockchain development company offering blockchain development services, crypto wallet, and certified blockchain developers for secure solutions
"
                         />
                       </Helmet>
                        )}

                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Blockchain Development
                            </div>
                            <div className="text-para">
                              Before discussing blockchain development it is
                              imperative that a basic idea of blockchain is
                              established. Blockchain is a fixed, digital ledger
                              that uses cryptography to record transactions and
                              tracks assets, both tangible and intangible, among
                              a distributed, peer-to-peer computer network.
                              Those transactions, known as blocks, are then
                              recorded, copied, and stored on each server,
                              called a node, that’s linked to the network.
                              Though Blockchain is primarily associated with
                              cryptocurrency development it is also being used
                              and in some industries where blockchain is
                              expected to be used includes healthcare, real
                              estate, finance, voting and supply chain but those
                              are really big industries in itself and require
                              too much capital investment. Blockchain are
                              currently principally being used in creation of
                              NFTs(non-fungible tokens), DAOs( decentralized
                              autonomous organizations) and cryptocurrency
                              development.
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}

            {accuratePath === "/web-3/smart-contract" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="web-design"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/web-3/smart-contract">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Smart Contract
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >

                        {/* <MetaTags>
                          <meta
                            id="meta-description"
                            name="description"
                            content=" Improve your business processes with our best smart contract services. Automate contracts and guarantee accuracy, speed, and trust now!"
                          />
                        </MetaTags> */}
                        <Helmet>
                          <title>Web3 Development & Smart Contract | Blockchain Technology</title>
                          <meta
                            name="keyword"
                            content="web3 development company, smart contracts blockchain, blockchains with smart contracts, blockchain technology smart contracts, smart contract agency"
                          />
                          <meta
                            name="description"
                            content="Trusted Web3 development company specializing in blockchain technology smart contracts, smart contracts blockchain, and blockchains with smart contracts.
"
                          />
                        </Helmet>


                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Smart Contract</div>
                            <div className="text-para">
                              Smart contracts are simply programs stored on a
                              blockchain that run when predetermined conditions
                              are met. They typically are used to automate the
                              execution of an agreement so that all participants
                              can be immediately certain of the outcome, without
                              any intermediary’s involvement or time loss.
                              Benefits of smart contracts include:{" "}
                            </div>
                            <ul>
                              <li>Speed and accuracy</li>
                              <li>Trust and transparency</li>
                              <li>Security</li>
                              <li>Savings</li>
                            </ul>
                            Smart contracts assist in functioning of
                            transactions by applying computer logic to every
                            transaction; they help decrease the time taken for
                            each transaction to fulfill and also make sure that
                            the transactions are error free. Also, the payment
                            made through these transactions are immediately
                            realized, hence leading to higher efficiency. Our
                            smart contract services include:
                            <ul>
                              <li>Smart contract architecture</li>
                              <li>Smart contract design and development</li>
                              <li>Smart contract audit</li>
                              <li>Smart contract optimization</li>
                            </ul>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}

            {accuratePath === "/web-3/crypto-wallet" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="web-design"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/web-3/crypto-wallet">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Crypto Wallet
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >

                        {/* <MetaTags>
                          <meta
                            id="meta-description"
                            name="description"
                            content="Protect your digital assets with our crypto wallet services. Our wallets guarantee the safety and accessibility of your cryptocurrency. Explore now! "
                          />
                        </MetaTags> */}


                        <Helmet>
                          <title>eWallet App Development Company | Digital Wallet Solutions</title>
                          <meta
                            name="keyword"
                            content="best crypto wallet, crypto defi wallet development company, white label wallet development, ewallet app development company, digital wallet app development company"
                          />
                          <meta
                            name="description"
                            content="Kindlebit is a trusted and leading ewallet app development company offering the best crypto wallet, white label wallet development, and DeFi wallet solutions.
"
                          />
                        </Helmet>
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Crypto Wallet</div>
                            <div className="text-para">
                              Just like storing physical currency, wallets are
                              used. Cryptocurrencies are stored in crypto
                              wallets. However, a crypto wallet can not only
                              store crypto currencies but can also store DeFi,
                              NFTs, DAOs etc,. A crypto wallet contains
                              passwords which give access to digital assets;
                              these can be in the form of highly encrypted USB
                              sticks or in the form of mobile apps which give
                              access to wallets. These wallets contain private
                              keys which give access to the wallet and provide
                              the ability to do transactions. Crypto wallets are
                              further classified into custodial and non
                              custodial wallets. Where custodial ones give
                              access to third parties for maintenance of private
                              keys and funds thus are more likely to get
                              attacked by hackers and non-custodial ones provide
                              full access to the user; since these aren’t stored
                              anywhere hence are less prone to attacks from
                              hackers. Our crypto wallet development services
                              include:
                            </div>
                            <ul>
                              <li>Web 3 wallet development</li>
                              <li>DeFi wallet development</li>
                              <li>Tron wallet development</li>
                              <li>White label wallet development</li>
                              <li>Multi currency wallet development</li>
                              <li>NFT wallet development</li>
                              <li>Ethereum wallet development</li>
                              <li>Web wallet development</li>
                              <li>Mobile wallet development</li>
                              <li>Desktop wallet development</li>
                              <li>Centralized wallet development</li>
                              <li>Bitcoin wallet development</li>
                              <li>Ethereum wallet development</li>
                              <li>Web wallet development</li>
                              <li>Mobile wallet development</li>
                              <li>Desktop wallet development</li>
                              <li>Centralized wallet development</li>
                            </ul>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}

            {accuratePath === "/web-3/tokenization" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="web-design"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/web-3/tokenization">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Tokenization
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >


                        <Helmet>
                          <title>Security Token & Authentication | RSA, Hardware, and NFTs</title>
                          <meta
                            name="keyword"
                            content="security token authentication, rsa security token, hardware token authentication, non fungible tokens"
                          />
                          <meta
                            name="description"
                            content="Providing security token authentication with RSA tokens, hardware token authentication, and expertise in non-fungible tokens for secure digital solutions
"
                          />
                        </Helmet>
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Tokenization</div>
                            <div className="text-para">
                              The process of tokenizing anything involves
                              turning it into a digital token that can be used
                              in a blockchain application. It transforms the
                              ownerships and rights of particular assets into a
                              digital form. By tokenization, you can transform
                              indivisible assets into token forms. Thus a single
                              asset can be bought by multiple holders through
                              the process of tokenization thus leading to parity
                              distribution of asset. There can be many different
                              types of tokens: security tokens, platform tokens,
                              utility tokens, fungible tokens, non- fungible
                              tokens etc. where each set of tokens serve a
                              particular purpose. Our asset tokenization
                              services include:
                            </div>
                            <ul>
                              <li>Real estate</li>
                              <li>Commodities</li>
                              <li>Documents</li>
                              <li>Utility assets</li>
                              <li>Security tokens</li>
                              <li>Fungible and non-fungible tokens</li>
                            </ul>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}

            {accuratePath === "/web-3/marketplace-development" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="web-design"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/web-3/marketplace-development">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Marketplace Development
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >

                        <Helmet>
                          <title>NFT Marketplace & eCommerce Development | Expert Developers</title>
                          <meta
                            name="keyword"
                            content="nft marketplace developers, marketplace app development, marketplace website development, ecommerce marketplace development"
                          />
                          <meta
                            name="description"
                            content="Expert NFT company offering marketplace app development, marketplace website development, and eCommerce marketplace development for scalable digital solutions
"
                          />
                        </Helmet>


                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Marketplace Development
                            </div>
                            <div className="text-para">
                              Any digital asset whether it is cryptocurrency or
                              token requires a marketplace where they can be
                              traded between people, thus many Web 3 based
                              startups are flocking to create a marketplace
                              where these digital assets can be traded. NFT
                              Marketplace is the most common marketplace where
                              different designers showcase their artwork which
                              are bought by people and this gives the exclusive
                              ownership over the artwork. For any marketplace to
                              work it requires certain infrastructure which
                              includes storefront, search items, filters,
                              listings, status of listing, buying and auction,
                              wallet, ratings etc. all these are imperative for
                              any marketplace to work. Our Marketplace
                              development services include:
                            </div>
                            <ul>
                              <li>NFT Marketplace Design and Development</li>
                              <li>NFT Smart Contract Development and Audit</li>
                              <li>NFT Marketplace Support and Maintenance</li>
                            </ul>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}

            {accuratePath === "/web-3/trading-bot" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="web-design"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/web-3/trading-bot">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Trading Bot
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Trading Bot</div>
                            <div className="text-para">
                              Trading Bot—a cutting-edge solution in
                              cryptocurrency trading. With precision and speed,
                              it executes strategic trades, capitalizing on
                              market opportunities. Experience heightened
                              efficiency and optimized trading outcomes as our
                              bot navigates the dynamic crypto landscape with
                              unparalleled accuracy.
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}
          </div>
        </section>
      </main>

      {/* Contact modal */}
      {commonModal && (
        <ContactModal
          commonModal={commonModal}
          setCommonModal={setCommonModal}
        />
      )}
    </>
  );
}
export default Blockchain;
